(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lt-christmas-tab"] && !Shopify.designMode) return;
  try {
    
$(function() {
  const section = $('.lt-christmas-tab');
  section.each(function() {
    const container = $(this).find('.tabs');
    const nav = container.find('.tab-item.active');
    const line = container.find('.tabs-line-active');
    const fWidth = container.width();
    const flkty = $(this).find('.flickityt4s').data('flickityt4s');
    function changeFlkty(idx) {
      flkty.selectCell(idx);
    }

    function setNav(nav) {
      const {left} = nav.position();
      const clipLeft = left;
      const clipRight = left + nav.width();
      const start = Number(100 - (clipRight / fWidth) * 100).toFixed();
      const end = Number((clipLeft / fWidth) * 100).toFixed();

      line.css('clipPath', `inset(0 ${start}% 0 ${end}% round var(--rd))`);
    }

    container.find('.tab-item').on('click', function() {
      container.find('.tab-item.active').removeClass('active');
      $(this).addClass('active');
      const idx = $(this).data('idx');
      setNav($(this));
      changeFlkty(idx);
    });
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-videos"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    const maxH = $('.lt-videos .carousel-videos .w__CustomVideo').outerHeight() * 3 + 20 * 2;
    const container = $('.lt-videos .carousel-videos');
    const defaultH = container.height();
    let isExpand = false;
    container.css('height', maxH + 'px');
    $('.lt-videos .more').on('click', function () {
      const newH = isExpand ? maxH : defaultH;
      isExpand = !isExpand;
      container.animate({ height: newH + 'px' });
      $(this)
        .find('span')
        .text(isExpand ? 'Collapse more' : 'Expand more');
      $(this).toggleClass('expand');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quickshop-modal"]) return;
  try {
    
  (function () {
    'use strict';

    /*
     * 运行时说明：
     *   V2 里这三个自定义元素都由 assets/cart-component.js 定义。bf26 没有那个文件，
     *   所以 cart-item-stepper / product-picker-modal 在这里做同名实现；
     *   variant-switcher 复用 bf26 b2g.js 里已有的那个（它只认 B2G 的数据源，读到
     *   这里的变体 JSON 为空会自行 return，不干扰下面的联动）。
     *   合并新版购物车后，本段整段删掉，交给 cart-component.js。
     */

    var QTY_EVENT = 'cart-item:qty-change';

    /* ── 数量步进器 <cart-item-stepper> ───────────────────────────────── */
    if (!customElements.get('cart-item-stepper')) {
      customElements.define(
        'cart-item-stepper',
        class extends HTMLElement {
          connectedCallback() {
            if (this._ready) return;
            this._ready = true;

            this.input = this.querySelector('[data-quantity-value]');
            this.decBtn = this.querySelector('[data-decrease-qty]');
            this.incBtn = this.querySelector('[data-increase-qty]');

            this.min = this.num('data-min', 1);
            this.max = this.num('data-max', 9999);
            this.step = this.num('data-step', 1) || 1;

            /*
             * 必须掐掉冒泡：bf26 的 assets/interactable.min.js 在 document 上做了事件委托
             *   s.on('click', '[data-quantity-selector]', …)
             *   s.on('change', '[data-quantity-value]', …)
             * 它会读 [data-quantity-value] 的当前值自行 ±step。本文件为与 V2 保持一致用的正是
             * 这套属性名，于是同一次点击跑两遍：这里先 1→2 并写回 input，委托再读到 2→3，
             * 症状就是「点一下加号跳到 3」。属性名不动，改在控件上掐冒泡。
             */
            if (this.decBtn) {
              this.decBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                this.jump(-1);
              });
            }
            if (this.incBtn) {
              this.incBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                this.jump(1);
              });
            }
            if (this.input) {
              // 手输时夹取；set() 只改 value，不会再触发 change，所以不会递归
              this.input.addEventListener('change', (e) => {
                e.stopPropagation();
                var v = parseFloat(this.input.value);
                this.set(isNaN(v) ? this.min : this.clamp(v), true);
              });
            }

            this.sync(false);
          }

          num(attr, fallback) {
            var v = parseFloat(this.getAttribute(attr));
            return isNaN(v) ? fallback : v;
          }

          get value() {
            var v = parseFloat(this.getAttribute('data-value'));
            if (!isNaN(v)) return this.clamp(v);
            return this.input ? parseFloat(this.input.value) || this.min : this.min;
          }

          clamp(v) {
            if (v < this.min) v = this.min;
            if (v > this.max) v = this.max;
            return v;
          }

          jump(dir) {
            var next = this.clamp(this.value + dir * this.step);
            if (next === this.value) return;
            this.set(next, true);
          }

          set(v, emit) {
            this.setAttribute('data-value', String(v));
            this.sync(emit);
          }

          sync(emit) {
            if (this._syncing) return;
            this._syncing = true;

            var v = this.value;
            this.setAttribute('data-value', String(v));
            if (this.input) {
              this.input.value = String(v);
              this.input.setAttribute('value', String(v));
            }
            if (this.decBtn) this.decBtn.disabled = v <= this.min;
            if (this.incBtn) this.incBtn.disabled = v >= this.max;

            this._syncing = false;

            if (emit) {
              this.dispatchEvent(new CustomEvent(QTY_EVENT, { bubbles: true, detail: { value: v } }));
            }
          }
        }
      );
    }

    /* ── 弹窗主体 <product-picker-modal> ──────────────────────────────── */
    if (!customElements.get('product-picker-modal')) {
      customElements.define(
        'product-picker-modal',
        class extends HTMLElement {
          connectedCallback() {
            if (this._ready) return;
            this._ready = true;

            this.addEventListener('click', (e) => this.onClick(e));

            var el = this.querySelector('[data-cart-variants-json]');
            try {
              this.variants = el ? JSON.parse(el.textContent) : [];
            } catch (_) {
              this.variants = [];
            }

            this.refreshAvailability();
            // 初始选中变体本身可能就无库存（全部缺货时 selected_or_first_available_variant 会落回第一个变体）
            this.syncConfirmState();
          }

          get variantId() {
            var v = parseInt(this.getAttribute('data-variant-id'), 10);
            return isNaN(v) ? null : v;
          }

          /* 当前选中变体在 variants JSON 里的记录；取不到返回 null（不擅自当作缺货） */
          currentVariant() {
            var id = this.variantId;
            if (!id) return null;
            for (var i = 0; i < this.variants.length; i++) {
              if (this.variants[i].id === id) return this.variants[i];
            }
            return null;
          }

          /* 当前选中：直接读服务端渲染出来的 is-active */
          selected() {
            var out = {};
            this.querySelectorAll('[data-pdp-option]').forEach((opt) => {
              var active = opt.querySelector('[data-pdp-swatch].is-active');
              if (active) out[opt.getAttribute('data-option-index')] = active.getAttribute('data-value');
            });
            return out;
          }

          /* 选中组合精确匹配的变体 */
          findVariant(sel) {
            var keys = Object.keys(sel);
            for (var i = 0; i < this.variants.length; i++) {
              var ok = true;
              for (var k = 0; k < keys.length; k++) {
                if (this.variants[i]['option' + (parseInt(keys[k], 10) + 1)] !== sel[keys[k]]) {
                  ok = false;
                  break;
                }
              }
              if (ok) return this.variants[i];
            }
            return null;
          }

          /* 该值在其它选项当前取值下是否有货 —— 对应 pdp-pf-option 的 is-soldout / is-cross */
          availability(opt, value) {
            var idx = parseInt(opt.getAttribute('data-option-index'), 10);
            var others = this.selected();
            delete others[opt.getAttribute('data-option-index')];

            var cross = false;
            for (var i = 0; i < this.variants.length; i++) {
              var v = this.variants[i];
              if (v['option' + (idx + 1)] !== value) continue;

              var matches = true;
              for (var key in others) {
                if (v['option' + (parseInt(key, 10) + 1)] !== others[key]) {
                  matches = false;
                  break;
                }
              }
              if (matches) {
                if (v.available) return 'available';
              } else if (v.available) {
                cross = true;
              }
            }
            return cross ? 'cross' : 'soldout';
          }

          refreshAvailability() {
            this.querySelectorAll('[data-pdp-option]').forEach((opt) => {
              opt.querySelectorAll('[data-pdp-swatch]').forEach((btn) => {
                var state = this.availability(opt, btn.getAttribute('data-value'));
                btn.classList.toggle('is-soldout', state === 'soldout');
                btn.classList.toggle('is-cross', state === 'cross');
                if (state === 'available') btn.removeAttribute('aria-disabled');
                else btn.setAttribute('aria-disabled', 'true');
              });
            });
          }

          onClick(e) {
            var btn = e.target.closest('[data-pdp-swatch]');
            if (!btn || !this.contains(btn)) return;

            var opt = btn.closest('[data-pdp-option]');
            if (!opt) return;

            var idx = parseInt(opt.getAttribute('data-option-index'), 10);
            var value = btn.getAttribute('data-value');

            // 该值在其它选项当前取值下完全无货 → 点不动
            if (this.availability(opt, value) === 'soldout') return;

            var variant = this.resolve(idx, value);
            if (!variant) return;

            this.applySelection(variant);
            this.refreshAvailability();
          }

          /*
           * 定出点击后要落的变体：
           *   能精确命中且可售 → 就用它；
           *   否则优先保留刚点的那个值（Pink 缺货时换 Size，Size 缺货时换 Color），
           *   在可售变体里挑与当前其余选项最接近的一个。
           * 这就是 V2 里「点 is-cross 的色 → 落到最近可售组合」的行为。
           */
          resolve(anchorIdx, anchorValue) {
            var sel = this.selected();
            sel[String(anchorIdx)] = anchorValue;

            var exact = null;
            var best = null;

            for (var i = 0; i < this.variants.length; i++) {
              var cand = this.variants[i];
              if (!cand.available) continue;
              if (cand['option' + (anchorIdx + 1)] !== anchorValue) continue;

              var score = 0;
              var complete = true;
              for (var key in sel) {
                var optValue = cand['option' + (parseInt(key, 10) + 1)];
                if (optValue !== sel[key]) complete = false;
                else if (key !== String(anchorIdx)) score++;
              }
              if (complete) {
                exact = cand;
                break;
              }
              if (!best || score > best.score) best = { variant: cand, score: score };
            }

            return exact || (best && best.variant) || null;
          }

          /* 把变体回写到 UI：选中态 + 选项头的当前值 */
          applySelection(variant) {
            this.querySelectorAll('[data-pdp-option]').forEach((opt) => {
              var idx = parseInt(opt.getAttribute('data-option-index'), 10);
              var target = variant['option' + (idx + 1)];

              opt.querySelectorAll('[data-pdp-swatch]').forEach((b) => {
                var on = b.getAttribute('data-value') === target;
                b.classList.toggle('is-active', on);
                b.setAttribute('aria-pressed', on ? 'true' : 'false');
              });

              var label = opt.querySelector('[data-pdp-current-value]');
              if (label && target != null) label.textContent = target;
            });

            this.apply(variant);
          }

          apply(variant) {
            this.setAttribute('data-variant-id', String(variant.id));

            var img = this.querySelector('[data-product-img]');
            if (img && variant.featured_image && variant.featured_image.src) {
              img.src = variant.featured_image.src;
            }

            var price = this.querySelector('[data-product-price]');
            if (price) price.textContent = this.money(variant.price, true);

            var compare = this.querySelector('[data-product-compare-price]');
            if (compare) {
              var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
              compare.textContent = hasCompare ? this.money(variant.compare_at_price, false) : '';
              compare.classList.toggle('is-hidden', !hasCompare);
            }

            // 选中变体的可售性同步到属性上（单变体商品没有 variants JSON，只能靠服务端这个值）
            this.setAttribute('data-variant-available', variant.available === false ? 'false' : 'true');

            // 切到无库存变体时，确认按钮要立刻回到禁用态
            this.syncConfirmState();

            this.dispatchEvent(
              new CustomEvent('quickshop:variant-change', { bubbles: true, detail: { variant: variant } })
            );
          }

          /*
           * 无库存的变体不允许加入清单 —— 同步弹窗 footer 的确认按钮（Add to Wishlist）。
           * 按钮由 snippets/dsm-modal.liquid 用 dsm-button 渲染（类 .js-dsm-dialog-confirm），
           * 禁用 / 解除都走 disabled + aria-disabled + dsm-btn--disabled（与 DSM 禁用态一致），
           * 同时把 aria-label / title 换成缺货文案，读屏与悬停能知道为什么点不动。
           * 数据源两级：多变体商品读 data-cart-variants-json 里当前变体的 available；
           * 单变体商品没有那份 JSON（服务端只在 has_only_default_variant=false 时输出），
           * 退回服务端渲染的 data-variant-available。都拿不到时不禁用，避免把可售商品锁死。
           */
          syncConfirmState() {
            var variant = this.currentVariant();
            var soldOut;
            if (variant) soldOut = variant.available === false;
            else soldOut = this.getAttribute('data-variant-available') === 'false';

            this.setAttribute('data-soldout', soldOut ? 'true' : 'false');

            var overlay = this.closest('[data-dsm-dialog]');
            var btn = overlay ? overlay.querySelector('.js-dsm-dialog-confirm') : null;
            if (!btn) return;

            var soldOutLabel = this.getAttribute('data-soldout-label') || '';
            var baseLabel = btn.getAttribute('data-label') || btn.textContent.trim();
            if (baseLabel && !btn.getAttribute('data-label')) btn.setAttribute('data-label', baseLabel);

            btn.classList.toggle('dsm-btn--disabled', soldOut);
            if (soldOut) {
              btn.setAttribute('disabled', 'disabled');
              btn.setAttribute('aria-disabled', 'true');
            } else {
              btn.removeAttribute('disabled');
              btn.removeAttribute('aria-disabled');
            }

            if (soldOutLabel) {
              var label = soldOut ? soldOutLabel : baseLabel;
              btn.setAttribute('aria-label', label);
              btn.setAttribute('title', label);
            }
          }

          /* plain=true → 只要金额（对应 money_without_currency，与服务端渲染的整数位一致） */
          money(cents, plain) {
            var amount = (cents / 100).toFixed(2);
            if (plain) return amount;
            var fmt = this.getAttribute('data-money-format');
            if (!fmt) return '$' + amount;
            // 用 RegExp 构造函数写，避免双花括号出现在源码里被 Liquid 当成输出
            var token = new RegExp('\\{\\{\\s*(\\w+)\\s*\\}\\}');
            return fmt.replace(token, function (m, key) {
              if (key === 'amount_no_decimals' || key === 'amount_no_decimals_with_comma_separator') {
                return String(Math.round(cents / 100));
              }
              return amount;
            });
          }

          /* 接入方取用：确认时要提交的变体、数量与商品快照
             available=false → 该变体无库存，不应写入清单（接入方据此再兜一层）
             handle 供清单存储做商品快照用（未来活动页没有本 section / 商品目录 JSON 时靠它反查商品） */
          collect() {
            var stepper = this.querySelector('cart-item-stepper');
            var variant = this.currentVariant();
            // 单变体商品没有 variants JSON，退回服务端渲染的 data-variant-available
            var available = variant
              ? variant.available !== false
              : this.getAttribute('data-variant-available') !== 'false';
            return {
              cartKey: null,
              variantId: this.variantId,
              qty: stepper ? stepper.value : 1,
              available: available,
              handle: this.getAttribute('data-product-handle') || '',
            };
          }
        }
      );
    }

    /* ── 确认：只派事件，加购由接入方决定 ─────────────────────────────── */
    document.addEventListener('dsm:dialog:confirm', function (e) {
      var dialog = e.target && e.target.closest ? e.target.closest('[data-dsm-dialog]') : null;
      if (!dialog) dialog = document.getElementById('quickshop-modal');

      var picker = dialog ? dialog.querySelector('[data-quickshop]') : null;
      if (picker && picker.hasAttribute('data-qs-cart')) return;
      // 只在「派发事件的那个弹窗」里找 picker：不要退回 document.querySelector ——
      // 同页任何一个 dsm 弹窗点确认都会派发本事件，全局兜底会命中页面上静态的 quickshop 副本，
      // 白造一条 cart:variant-update，把清单里同一变体的数量 +n（bfw:wishlist:add 现在是累加语义）
      if (!picker || typeof picker.collect !== 'function') return;

      var detail = picker.collect();
      if (!detail.variantId) return;
      // 无库存变体不加清单：按钮已禁用，这里再兜一层（防其它入口派发 confirm）
      if (detail.available === false) return;

      picker.dispatchEvent(new CustomEvent('cart:variant-update', { bubbles: true, detail: detail }));
    });

    if (!customElements.get('qs-modal-trigger')) {
      var triggerCache = new Map();

      function getModalOverlay(modalId) {
        return (
          document.getElementById(modalId + '-overlay') ||
          document.querySelector('[data-dsm-dialog="' + CSS.escape(modalId) + '"]')
        );
      }

      function extractContent(html, sectionId, contentSel) {
        var fragment = new DOMParser().parseFromString(html, 'text/html');
        // 响应里可能包着 #shopify-section-<id>（没有时退回整个文档）
        var scope = fragment.getElementById('shopify-section-' + sectionId) || fragment;
        if (contentSel) {
          var picked = scope.querySelector(contentSel);
          return picked ? picked.innerHTML : html;
        }
        // 没传 content-sel 的兜底：先摘掉 section 自己的弹窗容器，避免「弹窗注入弹窗」
        var ownOverlay = scope.querySelector('[data-dsm-dialog]');
        if (ownOverlay) ownOverlay.remove();
        return scope === fragment ? fragment.body.innerHTML : scope.innerHTML;
      }

      function injectIntoModal(overlay, html, targetSel) {
        var target =
          (targetSel && overlay.querySelector(targetSel)) ||
          overlay.querySelector('.dsm-modal__content') ||
          overlay.querySelector('.dsm-modal__body') ||
          overlay;
        target.innerHTML = html;
      }

      /** 把响应里的样式表提到 head（按 id / href 去重），返回等待加载的 Promise */
      function hoistStyles(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var links = Array.prototype.slice.call(doc.querySelectorAll('link[rel="stylesheet"]'));
        var pending = [];
        links.forEach(function (link) {
          link.remove();
          var existing = link.id
            ? document.getElementById(link.id)
            : document.head.querySelector('link[href="' + link.href + '"]');
          if (existing) return;
          var hoisted = link.cloneNode();
          pending.push(
            new Promise(function (resolve) {
              hoisted.addEventListener('load', resolve, { once: true });
              hoisted.addEventListener('error', resolve, { once: true });
            })
          );
          document.head.appendChild(hoisted);
        });
        return { html: doc.body.innerHTML, promise: Promise.all(pending) };
      }

      class QsModalTrigger extends HTMLElement {
        connectedCallback() {
          if (this._ac) return;
          this._ac = new AbortController();
          this.addEventListener('click', this, { signal: this._ac.signal });
        }

        disconnectedCallback() {
          if (this._ac) this._ac.abort();
          this._ac = null;
        }

        get sectionId() {
          return this.getAttribute('section-id') || '';
        }

        get modalId() {
          return this.getAttribute('modal-id') || '';
        }

        get src() {
          return this.getAttribute('src') || window.location.href;
        }

        get contentSel() {
          return this.getAttribute('content-sel') || null;
        }

        get targetSel() {
          return this.getAttribute('target-sel') || null;
        }

        get loadingClass() {
          return this.getAttribute('loading-class') || 'is-loading';
        }

        get mode() {
          return this.getAttribute('mode') || '';
        }

        get confirmLabel() {
          return this.getAttribute('confirm-label') || '';
        }

        get useCache() {
          return this.getAttribute('cache') !== 'false';
        }

        handleEvent(event) {
          if (event.type === 'click') this._open(event);
        }

        _open(event) {
          if (this.classList.contains(this.loadingClass)) {
            event.preventDefault();
            return;
          }
          // 让内部真正的交互元素自己处理（与主题版行为一致）
          if (event.target.closest('a[href], button[type="submit"], input, select, textarea')) return;
          event.preventDefault();

          var sectionId = this.sectionId;
          var modalId = this.modalId;
          if (!sectionId || !modalId) {
            console.warn('<qs-modal-trigger>: section-id / modal-id 必填');
            return;
          }

          var overlay = getModalOverlay(modalId);
          if (!overlay) {
            console.warn('<qs-modal-trigger>: 找不到弹窗 "' + modalId + '"，请在使用页面的模板里挂载该 section');
            return;
          }

          this._setLoading(overlay, true);

          this._fetch(sectionId)
            .then(
              function (html) {
                // 先把整段响应里的样式表提到 head（按 href 去重），再只取内容槽注入
                var hoisted = hoistStyles(html);
                return hoisted.promise.then(
                  function () {
                    var content = extractContent(hoisted.html, sectionId, this.contentSel);
                    if (!content.trim()) {
                      this._setLoading(overlay, false);
                      console.warn(
                        '<qs-modal-trigger>: section "' + sectionId + '" 渲染内容为空（product 上下文缺失？）'
                      );
                      return;
                    }
                    injectIntoModal(overlay, content, this.targetSel);
                    this._apply(overlay);
                    this._setLoading(overlay, false);
                    this._openModal(modalId, overlay);
                  }.bind(this)
                );
              }.bind(this)
            )
            .catch(
              function (error) {
                this._setLoading(overlay, false);
                console.error('<qs-modal-trigger> 拉取 section 失败:', error);
              }.bind(this)
            );
        }

        _setLoading(overlay, loading) {
          overlay.classList.toggle(this.loadingClass, loading);
          this.classList.toggle(this.loadingClass, loading);
          var button = this.querySelector('.bfw-shop__add');
          if (!button) return;
          button.disabled = loading;
          if (loading) button.setAttribute('aria-busy', 'true');
          else button.removeAttribute('aria-busy');
        }

        _apply(overlay) {
          if (overlay._dsmOnConfirm) delete overlay._dsmOnConfirm;
          var picker = overlay.querySelector('[data-quickshop]');
          if (this.mode === 'cart' && picker) {
            picker.setAttribute('data-qs-cart', '');
            this.dispatchEvent(new CustomEvent('qs:cart-open', { bubbles: true, detail: { overlay: overlay } }));
          }

          var label = this.confirmLabel;
          if (!label) return;
          var btn = overlay.querySelector('.js-dsm-dialog-confirm');
          if (!btn) return;
          btn.setAttribute('data-label', label);
          btn.setAttribute('aria-label', label);
          var span = btn.querySelector('.dsm-btn__label');
          if (span) span.textContent = label;
          else btn.textContent = label;
          if (picker && typeof picker.syncConfirmState === 'function') picker.syncConfirmState();
        }

        _fetch(sectionId) {
          var url = new URL(this.src, window.location.origin);
          url.searchParams.set('section_id', sectionId);
          url.searchParams.sort();
          var href = url.toString();

          if (this.useCache && triggerCache.has(href)) {
            return Promise.resolve(triggerCache.get(href));
          }

          return fetch(href, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          })
            .then(function (response) {
              if (!response.ok) throw new Error('qs-modal-trigger: HTTP ' + response.status);
              return response.text();
            })
            .then(
              function (html) {
                if (this.useCache) triggerCache.set(href, html);
                return html;
              }.bind(this)
            );
        }

        _openModal(modalId, overlay) {
          if (window.DsmDialog) {
            window.DsmDialog.open(modalId);
            return;
          }
          // 兜底：.dsm-overlay 靠 .is-open 显示（hidden 属性不参与可见性）
          overlay.removeAttribute('hidden');
          overlay.classList.add('is-open');
        }
      }

      customElements.define('qs-modal-trigger', QsModalTrigger);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-brand-pdp-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /**
     * v3-brand-pdp-tabs 交互逻辑
     *
     * 动画时序：
     *   1. 锁定容器高度（文档流中准确读取）
     *   2. 设置 CSS 方向变量
     *   3. 退场面板加 is-leaving（初始可见态 opacity:1 translateX(0)）
     *   4. 进场面板加 is-active（初始偏移态 opacity:0 translateX(enterFrom)）
     *   5. 加 is-animating → 两个面板变 absolute，CSS 初始态生效
     *   6. rAF 双帧确保初始态已绘制，再加 is-leaving-active + is-entering 同步触发过渡
     *   7. 420ms 后清理所有状态类
     */

    function initTabsSection(sectionEl) {
      var prefersReducedMotion =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var panelsWrap = sectionEl.querySelector('.v3-tabs__panels');
      var navWrap = sectionEl.querySelector('.v3-tabs__nav-wrap');
      var navEl = sectionEl.querySelector('.v3-tabs__nav');
      var navBtns = Array.prototype.slice.call(sectionEl.querySelectorAll('.v3-tabs__nav-btn'));
      var panels = Array.prototype.slice.call(sectionEl.querySelectorAll('.v3-tabs__panel'));

      if (!navBtns.length || !panels.length || !panelsWrap) return;

      var navIndicator = navEl ? navEl.querySelector('.v3-tabs__nav-indicator') : null;
      if (navEl && !navIndicator) {
        navIndicator = document.createElement('span');
        navIndicator.className = 'v3-tabs__nav-indicator';
        navIndicator.setAttribute('aria-hidden', 'true');
        navEl.insertBefore(navIndicator, navEl.firstChild);
      }

      var currentIndex = 0;
      var animating = false;
      var cleanupTimer = null;
      var rafOverflow = 0;

      function updateActiveIndicator(immediate) {
        if (!navEl || !navIndicator) return;
        var activeBtn = navBtns[currentIndex] || navEl.querySelector('.v3-tabs__nav-btn.is-active');
        if (!activeBtn) return;
        var navRect = navEl.getBoundingClientRect();
        var btnRect = activeBtn.getBoundingClientRect();
        var indicatorX = btnRect.left - navRect.left;
        if (immediate) navIndicator.style.transition = 'none';
        navEl.style.setProperty('--v3t-indicator-x', indicatorX + 'px');
        navEl.style.setProperty('--v3t-indicator-w', btnRect.width + 'px');
        if (immediate) {
          navIndicator.getBoundingClientRect();
          navIndicator.style.transition = '';
        }
      }

      function updateNavOverflow() {
        if (!navWrap || !navEl) return;
        var vw = window.innerWidth || document.documentElement.clientWidth || 0;
        if (vw > 768) {
          sectionEl.classList.remove('v3-tabs--nav-scroll');
          updateActiveIndicator(true);
          return;
        }
        var isOverflow = navEl.scrollWidth > navWrap.clientWidth + 1;
        sectionEl.classList.toggle('v3-tabs--nav-scroll', isOverflow);
        if (!isOverflow) navWrap.scrollLeft = 0;
        updateActiveIndicator(true);
      }

      /**
       * 将指定按钮滚动到 nav-wrap 可视区居中位置（仅 Mobile 横向滚动时生效）
       * @param {HTMLElement} btn
       */
      function scrollBtnIntoView(btn) {
        if (!navWrap || !navEl) return;
        // 只在 nav 实际超出 wrap 宽度时才滚动
        if (navEl.scrollWidth <= navWrap.clientWidth) return;
        var btnLeft = btn.offsetLeft;
        var btnWidth = btn.offsetWidth;
        var wrapWidth = navWrap.clientWidth;
        var targetScrollLeft = btnLeft - wrapWidth / 2 + btnWidth / 2;
        var maxScroll = Math.max(0, navWrap.scrollWidth - navWrap.clientWidth);
        if (targetScrollLeft < 0) targetScrollLeft = 0;
        if (targetScrollLeft > maxScroll) targetScrollLeft = maxScroll;
        navWrap.scrollTo({ left: targetScrollLeft, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
      }

      function getRenderableImgs(panelEl) {
        if (!panelEl) return [];
        var isMobile = (window.innerWidth || document.documentElement.clientWidth || 0) <= 768;
        var selector = isMobile ? '.v3-tabs__img--mob img' : '.v3-tabs__img--pc img';
        var imgs = panelEl.querySelectorAll(selector);
        if (imgs.length) return Array.prototype.slice.call(imgs);
        return Array.prototype.slice.call(panelEl.querySelectorAll('img'));
      }

      function getAllTabImgs() {
        return Array.prototype.slice.call(sectionEl.querySelectorAll('.v3-tabs__img-el'));
      }

      function updateImageSkeleton(img, loaded, errored) {
        var wrap = img && img.closest ? img.closest('.v3-tabs__img') : null;
        if (!wrap) return;
        wrap.classList.toggle('v3-tabs__img--loading', !loaded && !errored);
        wrap.classList.toggle('v3-tabs__img--loaded', loaded);
        wrap.classList.toggle('v3-tabs__img--error', errored);
      }

      function bindImageSkeletons(scopeEl) {
        var imgs = Array.prototype.slice.call((scopeEl || sectionEl).querySelectorAll('.v3-tabs__img-el'));
        imgs.forEach(function (img) {
          if (img.dataset.v3tabsSkeletonBound === '1') return;
          img.dataset.v3tabsSkeletonBound = '1';

          if (img.complete) {
            updateImageSkeleton(img, !!img.naturalWidth, !img.naturalWidth);
            return;
          }

          updateImageSkeleton(img, false, false);
          img.addEventListener('load', function () {
            updateImageSkeleton(img, true, false);
          }, { once: true });
          img.addEventListener('error', function () {
            updateImageSkeleton(img, false, true);
          }, { once: true });
        });
      }

      var allImagesPreloaded = false;
      function preloadAllTabImages() {
        if (allImagesPreloaded) return;
        allImagesPreloaded = true;
        var imgs = getAllTabImgs();
        imgs.forEach(function (img) {
          bindImageSkeletons(img.closest('.v3-tabs__panel') || sectionEl);

          try {
            img.loading = 'eager';
          } catch (ignore) {}

          if (img.complete) {
            updateImageSkeleton(img, !!img.naturalWidth, !img.naturalWidth);
            return;
          }

          var pre = new Image();
          pre.onload = function () {
            updateImageSkeleton(img, true, false);
          };
          pre.onerror = function () {
            updateImageSkeleton(img, false, true);
          };
          if (img.srcset) pre.srcset = img.srcset;
          if (img.sizes) pre.sizes = img.sizes;
          pre.src = img.currentSrc || img.src;
        });
      }

      function setupViewportPreload() {
        if (!('IntersectionObserver' in window)) {
          preloadAllTabImages();
          return;
        }

        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            preloadAllTabImages();
            observer.disconnect();
          });
        }, {
          root: null,
          rootMargin: '600px 0px',
          threshold: 0
        });

        observer.observe(sectionEl);
      }

      function isImgReady(img) {
        return !!(img && img.complete && img.naturalWidth);
      }

      function setPanelImageWaiting(panelEl, waiting) {
        if (!panelEl) return;
        panelEl.classList.toggle('is-image-waiting', waiting);
      }

      function preparePanelImageSkeleton(panelEl, forceWaiting) {
        if (!panelEl) return;
        bindImageSkeletons(panelEl);
        var imgs = getRenderableImgs(panelEl);
        var waiting = imgs.some(function (img) {
          return !isImgReady(img);
        });
        setPanelImageWaiting(panelEl, !!(forceWaiting && imgs.length) || waiting);
        imgs.forEach(function (img) {
          updateImageSkeleton(img, isImgReady(img), !!(img.complete && !img.naturalWidth));
        });
      }

      function clearPanelImageSkeletonWhenReady(panelEl, minDuration) {
        if (!panelEl) return;
        var startTime = Date.now();
        var imgs = getRenderableImgs(panelEl);
        if (!imgs.length) {
          setPanelImageWaiting(panelEl, false);
          return;
        }

        function refresh() {
          var stillWaiting = imgs.some(function (img) {
            return !img.complete;
          });
          var elapsed = Date.now() - startTime;
          if (!stillWaiting && minDuration && elapsed < minDuration) {
            setTimeout(refresh, minDuration - elapsed);
            return;
          }
          setPanelImageWaiting(panelEl, stillWaiting);
        }

        refresh();
        imgs.forEach(function (img) {
          if (img.complete) return;
          img.addEventListener('load', refresh, { once: true });
          img.addEventListener('error', refresh, { once: true });
        });
      }

      function getPanelHeight(panelEl, fallbackHeight) {
        if (!panelEl) return fallbackHeight || 0;
        var panelHeight = panelEl.offsetHeight;
        if (panelHeight > 0) return panelHeight;
        var imageWrap = panelEl.querySelector('.v3-tabs__panel-img-wrap');
        var imageWrapHeight = imageWrap ? imageWrap.getBoundingClientRect().height : 0;
        return imageWrapHeight || fallbackHeight || panelsWrap.offsetHeight || 1;
      }

      function activateTab(nextIndex) {
        if (nextIndex === currentIndex || animating) return;
        animating = true;
        clearTimeout(cleanupTimer);

        var prevPanel = panels[currentIndex];
        var nextPanel = panels[nextIndex];
        var goRight = nextIndex > currentIndex;
        var prevH = getPanelHeight(prevPanel, panelsWrap.offsetHeight);

        if (nextPanel) {
          preparePanelImageSkeleton(nextPanel, true);
          var nextImgs = getRenderableImgs(nextPanel);
          nextImgs.forEach(function (img) {
            // 通过 new Image() 预取，不修改已解析的 loading 属性（修改无效）
            if (!img.complete) {
              var pre = new Image();
              if (img.srcset) pre.srcset = img.srcset;
              if (img.sizes) pre.sizes = img.sizes;
              pre.src = img.currentSrc || img.src;
            }
          });
        }

        // 更新按钮状态
        navBtns.forEach(function (btn, i) {
          var active = i === nextIndex;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
          btn.setAttribute('tabindex', active ? '0' : '-1');
        });
        currentIndex = nextIndex;
        updateActiveIndicator(false);

        // ① 锁定容器高度（prevPanel 还在文档流中，读取准确）
        panelsWrap.style.height = prevH + 'px';

        // ② 写入方向 CSS 变量
        panelsWrap.style.setProperty('--v3t-enter-from', goRight ? '72px' : '-72px');
        panelsWrap.style.setProperty('--v3t-leave-to', goRight ? '-72px' : '72px');

        // ③ 退场面板打标（此时还未加 is-animating，面板仍在文档流，CSS 初始态为可见）
        prevPanel.classList.add('is-leaving');

        // ④ 进场面板激活（移除 hidden 使 AT 可读，此时同样未加 is-animating）
        nextPanel.removeAttribute('hidden');
        nextPanel.classList.add('is-active');
        clearPanelImageSkeletonWhenReady(nextPanel, prefersReducedMotion ? 0 : 420);
        var nextH = getPanelHeight(nextPanel, prevH);

        // ⑤ 开启动画模式 → 两个面板变 absolute，CSS 初始态（退场可见/进场偏移）立即生效
        panelsWrap.classList.add('is-animating');

        requestAnimationFrame(function () {
          panelsWrap.style.height = nextH + 'px';
          nextPanel.getBoundingClientRect();
          prevPanel.getBoundingClientRect();
          requestAnimationFrame(function () {
            prevPanel.classList.add('is-leaving-active'); // 退场：滑出
            nextPanel.classList.add('is-entering'); // 进场：滑入
          });
        });

        // ⑦ 过渡结束后清理（transition 时长 0.2s，多留 30ms 余量）
        cleanupTimer = setTimeout(function () {
          prevPanel.classList.remove('is-active', 'is-leaving', 'is-leaving-active', 'is-entering');
          setPanelImageWaiting(prevPanel, false);
          prevPanel.setAttribute('hidden', '');  // 退场面板恢复 hidden，AT 不再读取
          nextPanel.classList.remove('is-entering');
          panelsWrap.classList.remove('is-animating');
          panelsWrap.style.height = '';
          panelsWrap.style.removeProperty('--v3t-enter-from');
          panelsWrap.style.removeProperty('--v3t-leave-to');
          animating = false;
        }, 360);
      }

      // 点击
      navBtns.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          updateNavOverflow();
          scrollBtnIntoView(btn);
          activateTab(i);
          btn.focus();
        });
      });

      // 键盘方向键 + Tab 导航
      navBtns.forEach(function (btn) {
        btn.addEventListener('keydown', function (e) {
          var total = navBtns.length;
          if (e.key === 'ArrowRight') {
            e.preventDefault();
            activateTab((currentIndex + 1) % total);
            scrollBtnIntoView(navBtns[currentIndex]);
            navBtns[currentIndex].focus();
          } else if (e.key === 'ArrowLeft') {
            e.preventDefault();
            activateTab((currentIndex - 1 + total) % total);
            scrollBtnIntoView(navBtns[currentIndex]);
            navBtns[currentIndex].focus();
          } else if (e.key === 'Home') {
            e.preventDefault();
            activateTab(0);
            scrollBtnIntoView(navBtns[0]);
            navBtns[0].focus();
          } else if (e.key === 'End') {
            e.preventDefault();
            activateTab(total - 1);
            scrollBtnIntoView(navBtns[total - 1]);
            navBtns[total - 1].focus();
          } else if (e.key === 'Tab' && !e.shiftKey) {
            // Tab 键：将焦点从 tab button 移入当前激活的 panel（WAI-ARIA Tabs Pattern）
            var activePanel = panels[currentIndex];
            if (activePanel) {
              e.preventDefault();
              activePanel.focus();
            }
          }
        });
      });

      // 初始化：第一个面板直接显示，无动画
      panels[0].classList.add('is-active');
      bindImageSkeletons(sectionEl);
      updateActiveIndicator(true);
      updateNavOverflow();
      setupViewportPreload();
      window.addEventListener('resize', function () {
        if (rafOverflow) cancelAnimationFrame(rafOverflow);
        rafOverflow = requestAnimationFrame(function () {
          rafOverflow = 0;
          updateNavOverflow();
          updateActiveIndicator(true);
        });
      });
    }

    function init() {
      // 通过 data-initialized 标记防止同一元素被重复初始化
      document.querySelectorAll('.v3-tabs').forEach(function (el) {
        if (el.dataset.v3tabsInit) return;
        el.dataset.v3tabsInit = '1';
        initTabsSection(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (!e.detail || !e.detail.sectionId) return;
      var sectionEl = document.getElementById('shopify-section-' + e.detail.sectionId + '-content');
      if (sectionEl && sectionEl.classList.contains('v3-tabs') && !sectionEl.dataset.v3tabsInit) {
        sectionEl.dataset.v3tabsInit = '1';
        initTabsSection(sectionEl);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-baby-name-collection-list"] && !Shopify.designMode) return;
  try {
    
  (function (root, factory) {
    var api = factory();
    if (typeof module === 'object' && module.exports) module.exports = api;
    if (!root || !root.customElements || !root.HTMLElement) return;
    api.register(root);
  })(typeof window !== 'undefined' ? window : globalThis, function () {
    function normalizeGenderKey(value) {
      var normalized = String(value || '')
        .trim()
        .toLowerCase();
      if (normalized === 'f' || normalized === 'female' || normalized === 'girl') return 'girl';
      if (normalized === 'm' || normalized === 'male' || normalized === 'boy') return 'boy';
      return '';
    }

    function normalizeSavedPayload(response) {
      if (!response || (response.result && response.result !== 'success')) return null;
      var data = response.data || response;
      if (!data || !Array.isArray(data.baby_names)) return null;
      return {
        last_name: String(data.last_name || ''),
        baby_names: data.baby_names.map(function (item) {
          item = item || {};
          return Object.assign({}, item, {
            first_name: String(item.first_name || item.name || '').trim(),
            gender: normalizeGenderKey(item.gender),
          });
        }),
      };
    }

    function hasLoginCookie(cookieString, cookieName) {
      if (!cookieName) return false;
      var prefix = cookieName + '=';
      return String(cookieString || '')
        .split(';')
        .some(function (cookie) {
          var normalized = cookie.trim();
          return normalized.indexOf(prefix) === 0 && normalized.slice(prefix.length).trim() !== '';
        });
    }

    function hasAuthToken(root, doc) {
      var requestApi = root && root.MomcozyBabyNameRequest;
      if (requestApi && typeof requestApi.hasAuthToken === 'function') {
        return requestApi.hasAuthToken(root, doc);
      }
      var config = root && root.__MC__CONFIG__;
      var cookieName = config && config.cookieName ? config.cookieName : 'momcozy-token';
      return hasLoginCookie(doc && doc.cookie, cookieName);
    }

    function buildNamePayload(values) {
      return {
        baby_name: {
          first_name: String(values.first_name || '').trim(),
          middle_name: String(values.middle_name || '').trim(),
          gender: values.gender === 'boy' ? 'boy' : 'girl',
        },
        last_name: String(values.last_name || '').trim(),
      };
    }

    /**
     * Live generator: /pages/baby-name-generator
     * Copy/preview generator: /pages/baby-name-generator?view=yg-baby-name-upgrade
     */
    function defaultDetailPageUrl() {
      var livePath = '/pages/baby-name-generator';
      try {
        var search = typeof location !== 'undefined' && location.search ? location.search : '';
        var view = new URLSearchParams(search).get('view') || '';
        if (/upgrade|dev|copy|preview|test|beta/i.test(view)) {
          return livePath + '?view=' + encodeURIComponent(view);
        }
      } catch (error) {
        /* use live path */
      }
      return livePath;
    }

    function applyCollectionTemplate(template, vars) {
      var output = String(template || '');
      vars = vars || {};
      Object.keys(vars).forEach(function (key) {
        output = output.split('[[' + key + ']]').join(String(vars[key]));
      });
      return output;
    }

    function defaultCollectionLabels() {
      return {
        girlLabel: 'Girl',
        boyLabel: 'Boy',
        girlPossessive: "girl's",
        boyPossessive: "boy's",
        emptyTitleTemplate: 'Your [[gender_possessive]] baby names list is empty.',
        emptyCopyTemplate: 'Add [[gender_possessive]] names to your list to see them here.',
        addTitle: 'Add a Baby Name',
        editTitle: 'Edit a Baby Name',
        msgListFull: 'Your baby names list is full. Please remove a name before adding another.',
        msgSessionExpired: 'Your session has expired. Please sign in again.',
        msgUpdateError: 'We could not update your baby names list. Please try again.',
        msgOrderSaved: 'The name order was saved.',
        unnamedLabel: 'Unnamed baby name',
        detailPageUrl: defaultDetailPageUrl(),
        firstNameRequired: 'Please enter a first name.',
        loadUnavailable: 'Your baby names list is temporarily unavailable. Please try again.',
        loadGenericError: 'We could not load your baby names list. Please try again.',
        msgSavedTemplate: '[[name]] is saved to your baby names list.',
      };
    }

    function parseCollectionLabels(root) {
      var labels = defaultCollectionLabels();
      if (!root || !root.querySelector) return labels;
      var node = root.querySelector('[data-baby-name-collection-labels]');
      if (!node) return labels;
      try {
        return Object.assign(labels, JSON.parse(node.textContent || '{}') || {});
      } catch (error) {
        return labels;
      }
    }

    function buildDetailHref(firstName, labels) {
      var name = String(firstName || '').trim();
      if (!name) return '';
      labels = labels || defaultCollectionLabels();
      var base = String(labels.detailPageUrl || defaultCollectionLabels().detailPageUrl).trim();
      var joiner = base.indexOf('?') === -1 ? '?' : '&';
      return base + joiner + 'baby_name_view=detail&name=' + encodeURIComponent(name);
    }

    function moveItem(items, fromIndex, toIndex) {
      var copy = items.slice();
      if (!copy.length) return { items: copy, move: 1 };
      var from = Math.max(0, Math.min(copy.length - 1, Number(fromIndex) || 0));
      var to = Math.max(0, Math.min(copy.length - 1, Number(toIndex) || 0));
      var moved = copy.splice(from, 1)[0];
      copy.splice(to, 0, moved);
      return { items: copy, move: to + 1 };
    }

    function errorText(error) {
      if (!error) return '';
      var data = error.data;
      var dataText = '';
      if (typeof data === 'string') {
        dataText = data;
      } else if (data && typeof data === 'object') {
        dataText = data.reason || data.message || data.error || data.msg || '';
      }
      return [error.reason, error.message, error.error, error.msg, error.code, dataText].filter(Boolean).join(' ');
    }

    function isAuthFailure(error) {
      var status = Number(error && (error.status || error.statusCode || (error.response && error.response.status)));
      return status === 401 || status === 403 || /401|403|unauthor|token|login|session expired/i.test(errorText(error));
    }

    function getFailureMessage(error, labels) {
      labels = labels || defaultCollectionLabels();
      var text = errorText(error);
      if (/baby names list is full|list is full/i.test(text)) {
        return labels.msgListFull;
      }
      if (isAuthFailure(error)) return labels.msgSessionExpired;
      return labels.msgUpdateError;
    }

    function businessError(response) {
      if (!response || !response.result || response.result === 'success') return null;
      var error = new Error(response.reason || response.message || 'Request failed');
      error.reason = response.reason || response.message || '';
      error.status = response.status || response.code;
      return error;
    }

    function hasRequestClient(root) {
      var client = root && root.MomcozyBabyNameRequest;
      return Boolean(client && typeof client.getMyBabyNames === 'function');
    }

    function resolveRequestClient(root, options) {
      options = options || {};
      if (hasRequestClient(root)) {
        return Promise.resolve(root.MomcozyBabyNameRequest);
      }

      var timeout = options.timeout === undefined ? 10000 : options.timeout;
      var interval = options.interval === undefined ? 50 : options.interval;
      var signal = options.signal;

      return new Promise(function (resolve, reject) {
        var timeoutId = null;
        var intervalId = null;
        var settled = false;

        function cleanup() {
          if (timeoutId) root.clearTimeout(timeoutId);
          if (intervalId) root.clearInterval(intervalId);
          if (signal) signal.removeEventListener('abort', onAbort);
        }

        function finish(error, client) {
          if (settled) return;
          settled = true;
          cleanup();
          if (error) reject(error);
          else resolve(client);
        }

        function onAbort() {
          var abortError = new Error('Aborted');
          abortError.name = 'AbortError';
          finish(abortError);
        }

        function check() {
          if (hasRequestClient(root)) finish(null, root.MomcozyBabyNameRequest);
        }

        if (signal && signal.aborted) {
          onAbort();
          return;
        }
        if (signal) signal.addEventListener('abort', onAbort);

        intervalId = root.setInterval(check, interval);
        timeoutId = root.setTimeout(function () {
          finish(new Error('Baby Name request client unavailable'));
        }, timeout);
        check();
      });
    }

    function register(browserRoot) {
      if (browserRoot.customElements.get('baby-name-collection-list')) return;

      class BabyNameCollectionList extends browserRoot.HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.labels = parseCollectionLabels(this);
          this.activeGender = 'girl';
          this.names = [];
          this.lastName = '';
          this.loading = false;
          this.mutating = false;
          this.dragState = null;
          this.toastTimer = null;
          this.list = this.querySelector('[data-collection-list]');
          this.loadingNode = this.querySelector('[data-loading]');
          this.loadErrorNode = this.querySelector('[data-load-error]');
          this.loggedOutNode = this.querySelector('[data-logged-out]');
          this.emptyNode = this.querySelector('[data-empty]');
          this.statusNode = this.querySelector('[data-status]');
          this.rowTemplate = this.querySelector('[data-name-row-template]');
          this.editorForm = this.querySelector('[data-editor-form]');
          this.editorError = this.querySelector('[data-editor-error]');
          this.editorModal = this.querySelector('[data-editor-modal]');
          this.editorTitle = this.querySelector('[data-editor-title]');
          this.genderSelector = this.querySelector('[data-gender-selector]');
          this.genderOptions = this.querySelector('[data-gender-options]');
          this.genderText = this.querySelector('[data-gender-text]');
          this.genderInput = this.querySelector('[data-gender-input]');
          this.toastNode = this.querySelector('[data-toast]');
          this.toastText = this.querySelector('[data-toast-text]');
          this.dialogId = this.getAttribute('data-editor-dialog-id');
          this.boundClick = this.onClick.bind(this);
          this.boundSubmit = this.onSubmit.bind(this);
          this.boundPointerDown = this.onPointerDown.bind(this);
          this.boundPointerMove = this.onPointerMove.bind(this);
          this.boundPointerUp = this.onPointerUp.bind(this);
          this.boundPointerCancel = this.onPointerCancel.bind(this);
          this.boundKeydown = this.onKeydown.bind(this);
          this.boundDocClick = this.onDocumentClick.bind(this);
          this.addEventListener('click', this.boundClick);
          this.addEventListener('submit', this.boundSubmit);
          this.addEventListener('pointerdown', this.boundPointerDown);
          this.addEventListener('pointermove', this.boundPointerMove);
          this.addEventListener('pointerup', this.boundPointerUp);
          this.addEventListener('pointercancel', this.boundPointerCancel);
          browserRoot.document.addEventListener('keydown', this.boundKeydown);
          browserRoot.document.addEventListener('click', this.boundDocClick);
          this.lifecycleAbortController = browserRoot.AbortController ? new browserRoot.AbortController() : null;
          this.loadNames();
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.boundClick);
          this.removeEventListener('submit', this.boundSubmit);
          this.removeEventListener('pointerdown', this.boundPointerDown);
          this.removeEventListener('pointermove', this.boundPointerMove);
          this.removeEventListener('pointerup', this.boundPointerUp);
          this.removeEventListener('pointercancel', this.boundPointerCancel);
          browserRoot.document.removeEventListener('keydown', this.boundKeydown);
          browserRoot.document.removeEventListener('click', this.boundDocClick);
          if (this.toastTimer) browserRoot.clearTimeout(this.toastTimer);
          if (this.lifecycleAbortController) {
            this.lifecycleAbortController.abort();
            this.lifecycleAbortController = null;
          }
          this.initialized = false;
        }

        isLoggedIn() {
          return hasAuthToken(browserRoot, this.ownerDocument);
        }

        requestLogin() {
          this.dispatchEvent(
            new browserRoot.CustomEvent('baby-names:login-required', {
              bubbles: true,
            })
          );
        }

        get client() {
          return browserRoot.MomcozyBabyNameRequest;
        }

        setStatus(message, state) {
          if (!this.statusNode) return;
          this.statusNode.textContent = message || '';
          this.statusNode.hidden = !message;
          this.statusNode.setAttribute('data-state', state || 'info');
        }

        showToast(message, type) {
          if (!this.toastNode || !this.toastText || !message) return;
          if (this.toastTimer) browserRoot.clearTimeout(this.toastTimer);
          this.toastText.textContent = message;
          this.toastNode.setAttribute('data-state', type === 'error' ? 'error' : 'success');
          this.toastNode.hidden = false;
          this.toastTimer = browserRoot.setTimeout(
            function () {
              this.toastNode.hidden = true;
            }.bind(this),
            5000
          );
        }

        showLoggedOut() {
          this.loading = false;
          this.loadingNode.hidden = true;
          this.loadErrorNode.hidden = true;
          this.loggedOutNode.hidden = false;
          this.emptyNode.hidden = true;
          this.list.hidden = true;
          this.setStatus('', 'info');
        }

        showLoadError(message) {
          this.loadingNode.hidden = true;
          this.loadErrorNode.hidden = false;
          this.loggedOutNode.hidden = true;
          this.emptyNode.hidden = true;
          this.list.hidden = true;
          var copy = this.loadErrorNode.querySelector('[data-load-error-copy]');
          if (copy && message) copy.textContent = message;
          this.setStatus('', 'info');
        }

        async loadNames() {
          if (this.loading) return;
          this.loading = true;
          this.loadingNode.hidden = false;
          this.loadErrorNode.hidden = true;
          this.loggedOutNode.hidden = true;
          this.emptyNode.hidden = true;
          this.list.hidden = true;
          this.setStatus('', 'info');
          try {
            var client = await resolveRequestClient(browserRoot, {
              signal:
                this.lifecycleAbortController && this.lifecycleAbortController.signal
                  ? this.lifecycleAbortController.signal
                  : undefined,
            });
            if (!client) {
              this.showLoadError(this.labels.loadUnavailable);
              return;
            }
            if (!this.isLoggedIn()) {
              this.showLoggedOut();
              this.requestLogin();
              return;
            }
            var response = await client.getMyBabyNames();
            var requestError = businessError(response);
            if (requestError) throw requestError;
            var payload = normalizeSavedPayload(response);
            if (!payload) throw new Error('Invalid saved-name response');
            this.names = payload.baby_names;
            this.lastName = payload.last_name;
            browserRoot.ygMyBabyNamesList = {
              last_name: this.lastName,
              baby_names: this.names.slice(),
              status: 'loaded',
            };
            this.render();
          } catch (error) {
            if (error && error.name === 'AbortError') return;
            if (isAuthFailure(error)) {
              this.showLoggedOut();
              this.requestLogin();
            } else if (/request client unavailable/i.test(errorText(error))) {
              this.showLoadError(this.labels.loadUnavailable);
            } else {
              this.showLoadError(this.labels.loadGenericError);
            }
          } finally {
            this.loading = false;
            if (this.loadingNode) this.loadingNode.hidden = true;
          }
        }

        namesForGender() {
          var gender = this.activeGender;
          return this.names.filter(function (name) {
            return normalizeGenderKey(name.gender) === gender;
          });
        }

        render() {
          if (!this.isLoggedIn()) {
            this.showLoggedOut();
            return;
          }
          this.loadingNode.hidden = true;
          this.loadErrorNode.hidden = true;
          this.loggedOutNode.hidden = true;
          this.list.replaceChildren();
          var filtered = this.namesForGender();
          this.emptyNode.hidden = filtered.length !== 0;
          this.list.hidden = filtered.length === 0;
          if (!filtered.length) {
            var possessive = this.activeGender === 'boy' ? this.labels.boyPossessive : this.labels.girlPossessive;
            this.querySelector('[data-empty-title]').textContent = applyCollectionTemplate(
              this.labels.emptyTitleTemplate,
              { gender_possessive: possessive }
            );
            this.querySelector('[data-empty-copy]').textContent = applyCollectionTemplate(
              this.labels.emptyCopyTemplate,
              { gender_possessive: possessive }
            );
            return;
          }
          var fragment = this.ownerDocument.createDocumentFragment();
          filtered.forEach(
            function (name) {
              var row = this.rowTemplate.content.firstElementChild.cloneNode(true);
              var parts = [name.first_name, name.middle_name, this.lastName]
                .map(function (value) {
                  return String(value || '').trim();
                })
                .filter(Boolean);
              var fullName = parts.join(' ');
              row.setAttribute('data-name-id', name.id);
              row.setAttribute('data-name-first-name', name.first_name || '');
              row.setAttribute('data-name-middle-name', name.middle_name || '');
              row.setAttribute('data-name-rank', name.rank != null ? name.rank : '');
              var nameNode = row.querySelector('[data-name-text]');
              var firstName = String(name.first_name || '').trim();
              var detailHref = buildDetailHref(firstName, this.labels);
              if (detailHref) {
                nameNode.innerHTML = '';
                var link = this.ownerDocument.createElement('a');
                link.href = detailHref;
                link.textContent = firstName;
                nameNode.appendChild(link);
                if (name.middle_name) {
                  nameNode.appendChild(this.ownerDocument.createTextNode(' ' + name.middle_name));
                }
                if (this.lastName) {
                  nameNode.appendChild(this.ownerDocument.createTextNode(' ' + this.lastName));
                }
              } else {
                nameNode.textContent = fullName || this.labels.unnamedLabel;
              }
              row.querySelectorAll('button').forEach(
                function (button) {
                  if (this.mutating && !button.hasAttribute('data-drag-handle')) {
                    button.disabled = true;
                  }
                }.bind(this)
              );
              fragment.appendChild(row);
            }.bind(this)
          );
          this.list.appendChild(fragment);
        }

        findName(id) {
          return this.names.find(function (name) {
            return String(name.id) === String(id);
          });
        }

        closeGenderOptions() {
          if (!this.genderOptions) return;
          this.genderOptions.hidden = true;
          if (this.genderSelector) this.genderSelector.setAttribute('aria-expanded', 'false');
        }

        setGenderValue(value) {
          var gender = value === 'boy' ? 'boy' : 'girl';
          if (this.genderInput) this.genderInput.value = gender;
          if (this.genderText) {
            this.genderText.textContent = gender === 'boy' ? this.labels.boyLabel : this.labels.girlLabel;
          }
        }

        openEditor(name) {
          if (!this.editorForm || !this.editorModal) return;
          this.editorForm.reset();
          this.editorError.hidden = true;
          this.editorError.textContent = '';
          this.closeGenderOptions();
          var editing = Boolean(name);
          this.editorForm.elements.id.value = editing ? name.id : '';
          this.editorForm.elements.first_name.value = editing ? name.first_name || '' : '';
          this.editorForm.elements.middle_name.value = editing ? name.middle_name || '' : '';
          this.editorForm.elements.last_name.value = this.lastName || '';
          this.setGenderValue(editing ? (name.gender === 'boy' ? 'boy' : 'girl') : this.activeGender);
          if (this.editorTitle) {
            this.editorTitle.textContent = editing ? this.labels.editTitle : this.labels.addTitle;
          }
          var submitButton = this.editorForm.querySelector('[data-editor-submit]');
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.classList.remove('is-loading');
          }
          this.editorModal.hidden = false;
          this.editorModal.classList.add('is-open');
          this.editorModal.setAttribute('aria-hidden', 'false');
          this.ownerDocument.body.style.overflow = 'hidden';
          browserRoot.setTimeout(
            function () {
              this.editorForm.elements.first_name.focus();
            }.bind(this),
            100
          );
        }

        closeEditor() {
          if (!this.editorModal) return;
          this.editorModal.classList.remove('is-open');
          this.editorModal.setAttribute('aria-hidden', 'true');
          this.ownerDocument.body.style.overflow = '';
          this.closeGenderOptions();
          browserRoot.setTimeout(
            function () {
              if (!this.editorModal.classList.contains('is-open')) {
                this.editorModal.hidden = true;
              }
            }.bind(this),
            300
          );
        }

        onKeydown(event) {
          if (event.key === 'Escape' && this.editorModal && this.editorModal.classList.contains('is-open')) {
            this.closeEditor();
          }
        }

        onDocumentClick(event) {
          if (!this.genderOptions || this.genderOptions.hidden) return;
          if (event.target.closest('[data-gender-field]')) return;
          this.closeGenderOptions();
        }

        onClick(event) {
          var tab = event.target.closest('[data-gender]');
          if (tab && tab.getAttribute('role') === 'tab') {
            this.activeGender = tab.getAttribute('data-gender');
            this.querySelectorAll('[role="tab"]').forEach(function (button) {
              var active = button === tab;
              button.classList.toggle('is-active', active);
              button.setAttribute('aria-selected', active ? 'true' : 'false');
            });
            this.render();
            return;
          }

          if (event.target.closest('[data-retry]')) {
            this.loadNames();
            return;
          }

          if (event.target.closest('[data-add-name]')) {
            if (!this.requireLogin()) return;
            this.openEditor(null);
            return;
          }

          if (event.target.closest('[data-editor-close]')) {
            this.closeEditor();
            return;
          }

          if (event.target.closest('[data-gender-selector]')) {
            event.stopPropagation();
            if (!this.genderOptions) return;
            var open = this.genderOptions.hidden;
            this.genderOptions.hidden = !open;
            this.genderSelector.setAttribute('aria-expanded', open ? 'true' : 'false');
            return;
          }

          var genderOption = event.target.closest('[data-value]');
          if (genderOption && genderOption.closest('[data-gender-options]')) {
            this.setGenderValue(genderOption.getAttribute('data-value'));
            this.closeGenderOptions();
            return;
          }

          var row = event.target.closest('[data-name-id]');
          if (!row || this.mutating) return;
          var id = row.getAttribute('data-name-id');
          if (event.target.closest('[data-edit-name]')) {
            if (!this.requireLogin()) return;
            this.openEditor(this.findName(id));
            return;
          }
          if (event.target.closest('[data-remove-name]')) {
            if (!this.requireLogin()) return;
            this.removeName(id);
          }
        }

        requireLogin() {
          if (this.isLoggedIn()) return true;
          this.showLoggedOut();
          this.requestLogin();
          return false;
        }

        async onSubmit(event) {
          if (!event.target.matches('[data-editor-form]')) return;
          event.preventDefault();
          event.stopPropagation();
          if (this.mutating || !this.requireLogin()) return;
          var values = {
            first_name: this.editorForm.elements.first_name.value,
            middle_name: this.editorForm.elements.middle_name.value,
            last_name: this.editorForm.elements.last_name.value,
            gender: this.genderInput ? this.genderInput.value : this.editorForm.elements.gender.value,
          };
          var payload = buildNamePayload(values);
          var firstNameInput = this.editorForm.elements.first_name;
          if (!payload.baby_name.first_name) {
            firstNameInput.setAttribute('aria-invalid', 'true');
            this.editorError.textContent = this.labels.firstNameRequired;
            this.editorError.hidden = false;
            firstNameInput.focus();
            return;
          }
          firstNameInput.removeAttribute('aria-invalid');
          this.editorError.hidden = true;
          var id = this.editorForm.elements.id.value;
          var submitButton = this.editorForm.querySelector('[data-editor-submit]');
          this.mutating = true;
          if (submitButton) {
            submitButton.disabled = true;
            submitButton.classList.add('is-loading');
            submitButton.setAttribute('aria-busy', 'true');
          }
          try {
            if (!this.client) throw new Error('Client unavailable');
            var response = id
              ? await this.client.updateMyBabyName(id, payload)
              : await this.client.addMyBabyName(payload);
            var requestError = businessError(response);
            if (requestError) throw requestError;
            this.closeEditor();
            this.mutating = false;
            await this.loadNames();
            var successMessage = applyCollectionTemplate(this.labels.msgSavedTemplate, {
              name: payload.baby_name.first_name,
            });
            this.setStatus(successMessage, 'success');
            this.showToast(successMessage, 'success');
          } catch (error) {
            this.mutating = false;
            this.editorError.textContent = getFailureMessage(error, this.labels);
            this.editorError.hidden = false;
            this.showToast(getFailureMessage(error, this.labels), 'error');
            if (isAuthFailure(error)) this.requestLogin();
          } finally {
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.classList.remove('is-loading');
              submitButton.removeAttribute('aria-busy');
            }
          }
        }

        async removeName(id) {
          var name = this.findName(id);
          if (!name || !this.client || typeof this.client.deleteMyBabyName !== 'function') return;
          this.mutating = true;
          this.render();
          try {
            var response = await this.client.deleteMyBabyName(id);
            var requestError = businessError(response);
            if (requestError) throw requestError;
            this.mutating = false;
            await this.loadNames();
            var message = (name.first_name || 'The name') + ' was removed from your list.';
            this.setStatus(message, 'success');
            this.showToast(message, 'success');
          } catch (error) {
            this.mutating = false;
            this.render();
            this.setStatus(getFailureMessage(error, this.labels), 'error');
            this.showToast(getFailureMessage(error, this.labels), 'error');
            if (isAuthFailure(error)) this.requestLogin();
          }
        }

        replaceGenderOrder(ordered) {
          var gender = this.activeGender;
          var cursor = 0;
          return this.names.map(function (name) {
            if (String(name.gender || '').toLowerCase() !== gender) return name;
            var replacement = ordered[cursor];
            cursor += 1;
            return replacement;
          });
        }

        async persistMove(id, from, to) {
          if (!this.client || typeof this.client.sortMyBabyName !== 'function') return;
          var snapshot = this.names.slice();
          var result = moveItem(this.namesForGender(), from, to);
          this.names = this.replaceGenderOrder(result.items);
          this.mutating = true;
          this.render();
          try {
            var response = await this.client.sortMyBabyName({
              baby_name: { id: id, move: result.move },
            });
            var requestError = businessError(response);
            if (requestError) throw requestError;
            this.mutating = false;
            await this.loadNames();
            this.setStatus(this.labels.msgOrderSaved, 'success');
          } catch (error) {
            this.names = snapshot;
            this.mutating = false;
            this.render();
            this.setStatus(getFailureMessage(error, this.labels), 'error');
            this.showToast(getFailureMessage(error, this.labels), 'error');
            if (isAuthFailure(error)) this.requestLogin();
          }
        }

        onPointerDown(event) {
          var handle = event.target.closest('[data-drag-handle]');
          if (!handle || this.mutating || !this.requireLogin()) return;
          var row = handle.closest('[data-name-id]');
          if (!row || !this.list.contains(row)) return;
          var rows = Array.from(this.list.querySelectorAll('[data-name-id]'));
          this.dragState = {
            id: row.getAttribute('data-name-id'),
            pointerId: event.pointerId,
            from: rows.indexOf(row),
            row: row,
            handle: handle,
          };
          row.classList.add('is-dragging');
          if (handle.setPointerCapture) handle.setPointerCapture(event.pointerId);
          event.preventDefault();
        }

        onPointerMove(event) {
          if (!this.dragState || event.pointerId !== this.dragState.pointerId) return;
          var target = this.ownerDocument.elementFromPoint(event.clientX, event.clientY);
          var targetRow = target && target.closest('[data-name-id]');
          if (!targetRow || targetRow === this.dragState.row || !this.list.contains(targetRow)) return;
          var rect = targetRow.getBoundingClientRect();
          var before = event.clientY < rect.top + rect.height / 2;
          this.list.insertBefore(this.dragState.row, before ? targetRow : targetRow.nextElementSibling);
          event.preventDefault();
        }

        onPointerUp(event) {
          if (!this.dragState || event.pointerId !== this.dragState.pointerId) return;
          var state = this.dragState;
          var rows = Array.from(this.list.querySelectorAll('[data-name-id]'));
          var to = rows.indexOf(state.row);
          state.row.classList.remove('is-dragging');
          if (state.handle.releasePointerCapture && state.handle.hasPointerCapture(event.pointerId)) {
            state.handle.releasePointerCapture(event.pointerId);
          }
          this.dragState = null;
          if (to === state.from) {
            this.render();
            return;
          }
          this.persistMove(state.id, state.from, to);
        }

        onPointerCancel(event) {
          if (!this.dragState || event.pointerId !== this.dragState.pointerId) return;
          this.dragState.row.classList.remove('is-dragging');
          this.dragState = null;
          this.render();
        }
      }

      browserRoot.customElements.define('baby-name-collection-list', BabyNameCollectionList);
    }

    return {
      normalizeSavedPayload: normalizeSavedPayload,
      hasLoginCookie: hasLoginCookie,
      hasAuthToken: hasAuthToken,
      hasRequestClient: hasRequestClient,
      resolveRequestClient: resolveRequestClient,
      buildNamePayload: buildNamePayload,
      buildDetailHref: buildDetailHref,
      moveItem: moveItem,
      isAuthFailure: isAuthFailure,
      getFailureMessage: getFailureMessage,
      register: register,
    };
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-baby-name-generation"] && !Shopify.designMode) return;
  try {
    
  (function (root, factory) {
    var api = factory(root);

    if (typeof module === 'object' && module.exports) {
      module.exports = api;
    }

    if (root) {
      root.MomcozyBabyNameGeneration = api;
      api.boot(root.document);
    }
  })(typeof window !== 'undefined' ? window : null, function (browserRoot) {
    var initializedDocuments = typeof WeakSet === 'function' ? new WeakSet() : null;

    function normalizeText(value) {
      return typeof value === 'string' ? value.trim() : '';
    }

    function getFormValue(form, name) {
      if (!form || !form.elements || typeof form.elements.namedItem !== 'function') return '';
      var field = form.elements.namedItem(name);
      return field && typeof field.value !== 'undefined' ? field.value : '';
    }

    function collectFormState(form) {
      return {
        gender: normalizeText(getFormValue(form, 'gender')),
        surname: normalizeText(getFormValue(form, 'surname')),
        starting: normalizeText(getFormValue(form, 'starting')),
        ending: normalizeText(getFormValue(form, 'ending')),
        syllables: normalizeText(getFormValue(form, 'syllables')),
        meanings: normalizeText(getFormValue(form, 'meanings')),
        theme: normalizeText(getFormValue(form, 'theme')),
        origin: normalizeText(getFormValue(form, 'origin')),
      };
    }

    function nullable(value) {
      var normalized = normalizeText(value);
      return normalized || null;
    }

    function buildGeneratePayload(formState) {
      formState = formState || {};
      var syllables = parseInt(formState.syllables, 10);

      return {
        filter: {
          gender: nullable(formState.gender),
          surname: nullable(formState.surname),
          starting: nullable(formState.starting),
          ending: nullable(formState.ending),
          syllables: Number.isFinite(syllables) && syllables > 0 ? syllables : null,
          meanings: nullable(formState.meanings),
          theme: nullable(formState.theme),
          origin: nullable(formState.origin),
        },
        sorting: null,
        page: 1,
        pagesize: 15,
      };
    }

    var SURNAME_SUGGESTIONS_INITIAL = 3;

    function getSurnameSuggestions(config, surname, options) {
      var normalizedSurname = normalizeText(surname).toLowerCase();
      if (!normalizedSurname || !config || typeof config !== 'object') return [];

      var exact = Array.isArray(config[normalizedSurname]) ? config[normalizedSurname] : null;
      var fallback = Array.isArray(config.default) ? config.default : [];
      var list = (exact || fallback).filter(function (item) {
        return item && typeof item === 'object' && normalizeText(item.first_name);
      });

      // Default keeps the collapsed preview (first 3). Pass { limit: 0 } or omit limit for all.
      var limit =
        options && Object.prototype.hasOwnProperty.call(options, 'limit') ? options.limit : SURNAME_SUGGESTIONS_INITIAL;
      if (typeof limit === 'number' && limit > 0) return list.slice(0, limit);
      return list;
    }

    function parseSurnameConfig(rootElement) {
      var configElement = rootElement.querySelector('[data-baby-name-surname-config]');
      if (!configElement) return {};

      try {
        var parsed = JSON.parse(configElement.textContent || '{}');
        return parsed && typeof parsed === 'object' ? parsed : {};
      } catch (error) {
        return {};
      }
    }

    function dispatch(rootElement, eventName, detail) {
      if (!browserRoot || typeof browserRoot.CustomEvent !== 'function') return;
      rootElement.dispatchEvent(
        new browserRoot.CustomEvent(eventName, {
          bubbles: true,
          detail: detail || {},
        })
      );
    }

    function setStatus(element, message) {
      if (element) element.textContent = message || '';
    }

    function getRequestClient() {
      return browserRoot && browserRoot.MomcozyBabyNameRequest ? browserRoot.MomcozyBabyNameRequest : null;
    }

    /**
     * 判断 API data 字段是否有有效内容。
     * 空结果仍会返回对象壳，但字段全为 null / 空数组，例如：
     * { old_mean_article: null, similar_name_list: [], ... }
     */
    function hasMeaningfulValue(value) {
      if (value === null || value === undefined || value === false) return false;
      if (typeof value === 'string') return Boolean(value.trim());
      if (Array.isArray(value)) {
        return value.some(function (item) {
          return hasMeaningfulValue(item);
        });
      }
      if (typeof value === 'object') {
        return Object.keys(value).some(function (key) {
          return hasMeaningfulValue(value[key]);
        });
      }
      return true;
    }

    /**
     * GET baby_names_info_page 成功且 data 内有实质内容才视为命中。
     * 兼容旧版 path 字符串，以及详情对象响应。
     */
    function hasNameSearchResult(response) {
      if (!response || (response.result && response.result !== 'success')) return false;
      return hasMeaningfulValue(response.data);
    }

    function resolveSearchDetailName(searchName, response) {
      var fallback = normalizeText(searchName);
      if (!response || response.data == null) return fallback;

      var data = response.data;
      if (typeof data === 'object' && !Array.isArray(data)) {
        var fromData = normalizeText(data.name || data.first_name);
        if (fromData) return fromData;
      }

      return fallback;
    }

    /**
     * 搜索接口 400 / failure 体（如 error_code 10020002）视为「找不到名字」，
     * 而不是网络错误。
     */
    function isSearchNameNotFoundError(error) {
      if (!error) return false;
      var status = Number(error.status);
      if (status === 400 || status === 404) return true;

      var data = error.data;
      if (data && typeof data === 'object') {
        if (String(data.result || '').toLowerCase() === 'failure') return true;
        if (String(data.error_code || '') === '10020002') return true;
      }

      var text = [error.message, error.reason, error.code]
        .concat(data && typeof data === 'object' ? [data.reason, data.message, data.msg] : [])
        .filter(Boolean)
        .join(' ');
      return /name not found|not found|unknown name|no such name/i.test(text);
    }

    function readGenerationLabels(root) {
      var defaults = {
        suggestionsHeadingTemplate: 'Sounds lovely with "[[surname]]"—',
        searchEmptyError: 'Please enter a name to search.',
        searchUnavailableError: 'Search is temporarily unavailable. Please try again later.',
        searchNotFoundTemplate: 'We couldn\'t find any information for the name "[[name]]"',
        searchNetworkError: 'Network error. Please try again later.',
      };
      if (!root || !root.querySelector) return defaults;
      var node = root.querySelector('[data-baby-name-generation-labels]');
      if (!node) return defaults;
      try {
        var parsed = JSON.parse(node.textContent || '{}');
        return Object.assign({}, defaults, parsed || {});
      } catch (error) {
        return defaults;
      }
    }

    function applyGenerationTemplate(template, vars) {
      var output = String(template || '');
      vars = vars || {};
      Object.keys(vars).forEach(function (key) {
        output = output.split('[[' + key + ']]').join(String(vars[key]));
      });
      return output;
    }

    function nameNotFoundMessage(name, labels) {
      labels = labels || readGenerationLabels();
      return applyGenerationTemplate(labels.searchNotFoundTemplate, { name: name });
    }

    function ensureSearchButtonSpinner(button) {
      if (!button || !button.ownerDocument) return null;
      var spinner = button.querySelector('[data-baby-name-button-spinner]');
      if (spinner) return spinner;
      spinner = button.ownerDocument.createElement('span');
      spinner.className = 'yg-bn-spinner yg-bn-spinner--button';
      spinner.setAttribute('data-baby-name-button-spinner', '');
      spinner.setAttribute('aria-hidden', 'true');
      button.appendChild(spinner);
      return spinner;
    }

    function setButtonBusy(button, busy) {
      if (!button) return;

      var ui = browserRoot && browserRoot.MomcozyBabyNameUI;
      if (ui && typeof ui.setButtonLoading === 'function') {
        ui.setButtonLoading(button, busy);
        return;
      }

      if (busy) {
        if (!button.style.minWidth) {
          var width = button.offsetWidth;
          if (width) button.style.minWidth = width + 'px';
        }
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        ensureSearchButtonSpinner(button);
        return;
      }

      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
      button.style.minWidth = '';
      var spinner = button.querySelector('[data-baby-name-button-spinner]');
      if (spinner) spinner.remove();
    }

    function setButtonEnabled(button, enabled) {
      if (!button) return;
      if (enabled) {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        button.classList.remove('yg-baby-name-button--disabled');
      } else {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('yg-baby-name-button--disabled');
      }
    }

    function createSuggestionRow(doc, suggestion, surname) {
      var row = doc.createElement('div');
      var name = doc.createElement('span');
      var meta = doc.createElement('span');
      var origin = normalizeText(suggestion.origin);
      var meaning = normalizeText(suggestion.meaning);

      row.className = 'yg-bn-generation__suggestion';
      row.setAttribute('role', 'listitem');
      name.className = 'yg-bn-generation__suggestion-name';
      meta.className = 'yg-bn-generation__suggestion-meta';
      name.textContent = normalizeText(suggestion.first_name) + ' ' + surname;
      meta.textContent = [origin, meaning].filter(Boolean).join(' · ');
      row.appendChild(name);
      row.appendChild(meta);
      return row;
    }

    function init(rootElement) {
      if (!rootElement || rootElement.getAttribute('data-baby-name-generation-initialized') === 'true') return;
      rootElement.setAttribute('data-baby-name-generation-initialized', 'true');

      var doc = rootElement.ownerDocument;
      var generationForm = rootElement.querySelector('[data-baby-name-generation-form]');
      var searchForm = rootElement.querySelector('[data-baby-name-search-form]');
      var surnameInput = rootElement.querySelector('[data-baby-name-surname-input]');
      var suggestionsPanel = rootElement.querySelector('[data-baby-name-surname-suggestions]');
      var suggestionsHeading = rootElement.querySelector('[data-baby-name-suggestions-heading]');
      var suggestionsList = rootElement.querySelector('[data-baby-name-suggestions-list]');
      var suggestionsMore = rootElement.querySelector('[data-baby-name-suggestions-more]');
      var filtersPanel = rootElement.querySelector('[data-baby-name-filters-panel]');
      var filterToggle = rootElement.querySelector('[data-baby-name-action="toggle-filters"]');
      var generationStatus = rootElement.querySelector('[data-baby-name-generation-status]');
      var searchInput = rootElement.querySelector('[data-baby-name-search-input]');
      var searchError = rootElement.querySelector('[data-baby-name-search-error]');
      var searchButton = rootElement.querySelector('[data-baby-name-action="search"]');
      var surnameConfig = parseSurnameConfig(rootElement);
      var labels = readGenerationLabels(rootElement);
      var suggestionsExpanded = false;
      var lastSuggestionsSurname = '';
      var isSearching = false;

      function setFiltersOpen(open) {
        var isOpen = Boolean(open);
        rootElement.setAttribute('data-filters-open', isOpen ? 'true' : 'false');
        if (filtersPanel) {
          filtersPanel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
          if ('inert' in filtersPanel) filtersPanel.inert = !isOpen;
          if (!isOpen && filtersPanel.contains(doc.activeElement) && filterToggle) filterToggle.focus();
        }
        if (filterToggle) filterToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }

      function adjustSyllables(step) {
        var syllablesInput = generationForm && generationForm.querySelector('input[name="syllables"]');
        if (!syllablesInput) return;
        var current = parseInt(syllablesInput.value, 10);
        if (step > 0) {
          syllablesInput.value = String(Number.isFinite(current) && current > 0 ? current + step : 1);
          return;
        }
        if (!Number.isFinite(current) || current <= 1) {
          syllablesInput.value = '';
          return;
        }
        syllablesInput.value = String(current + step);
      }

      function hideSuggestions() {
        if (suggestionsPanel) suggestionsPanel.hidden = true;
      }

      function setSuggestionsMoreVisible(visible) {
        if (!suggestionsMore) return;
        suggestionsMore.hidden = !visible;
      }

      function renderSuggestions(options) {
        if (!surnameInput || !suggestionsPanel || !suggestionsHeading || !suggestionsList) return;
        options = options || {};
        var surname = normalizeText(surnameInput.value);

        if (surname !== lastSuggestionsSurname) {
          suggestionsExpanded = false;
          lastSuggestionsSurname = surname;
        }
        if (options.expand) suggestionsExpanded = true;

        var allSuggestions = getSurnameSuggestions(surnameConfig, surname, { limit: 0 });
        var visibleSuggestions = suggestionsExpanded
          ? allSuggestions
          : allSuggestions.slice(0, SURNAME_SUGGESTIONS_INITIAL);

        suggestionsList.replaceChildren();
        if (!surname || !allSuggestions.length) {
          setSuggestionsMoreVisible(false);
          hideSuggestions();
          return;
        }

        suggestionsHeading.textContent = applyGenerationTemplate(labels.suggestionsHeadingTemplate, {
          surname: surname,
        });
        visibleSuggestions.forEach(function (suggestion) {
          suggestionsList.appendChild(createSuggestionRow(doc, suggestion, surname));
        });
        setSuggestionsMoreVisible(allSuggestions.length > visibleSuggestions.length);
        suggestionsPanel.hidden = false;
      }

      function startGeneration() {
        if (!generationForm) return;
        var payload = buildGeneratePayload(collectFormState(generationForm));
        setStatus(generationStatus, '');
        dispatch(rootElement, 'baby-names:generate', { payload: payload });
      }

      function syncSearchButtonState() {
        if (!searchButton || isSearching) return;
        setButtonEnabled(searchButton, Boolean(searchInput && normalizeText(searchInput.value)));
      }

      function startSearch() {
        if (!searchInput || isSearching) return;

        var name = normalizeText(searchInput.value);
        if (!name) {
          setStatus(searchError, labels.searchEmptyError);
          setButtonEnabled(searchButton, false);
          searchInput.focus();
          return;
        }

        var client = getRequestClient();
        if (!client || typeof client.getNameInfo !== 'function') {
          setStatus(searchError, labels.searchUnavailableError);
          return;
        }

        // Preflight: only navigate to detail when baby_names_info_page has real data.
        isSearching = true;
        setStatus(searchError, '');
        setButtonBusy(searchButton, true);

        Promise.resolve()
          .then(function () {
            return client.getNameInfo(name);
          })
          .then(function (response) {
            if (!hasNameSearchResult(response)) {
              setStatus(searchError, nameNotFoundMessage(name, labels));
              return;
            }

            // 有返回值则进入详情路由：baby_name_view=detail&name=...
            dispatch(rootElement, 'baby-names:search', {
              name: resolveSearchDetailName(name, response),
              response: response,
            });
          })
          .catch(function (error) {
            // 400 BAD REQUEST + failure body → treat as unknown name, stay on entry.
            if (isSearchNameNotFoundError(error)) {
              setStatus(searchError, nameNotFoundMessage(name, labels));
              return;
            }
            setStatus(searchError, labels.searchNetworkError);
          })
          .then(function () {
            isSearching = false;
            setButtonBusy(searchButton, false);
            syncSearchButtonState();
          });
      }

      rootElement.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-baby-name-action]');
        if (!trigger || !rootElement.contains(trigger)) return;
        var action = trigger.getAttribute('data-baby-name-action');

        if (action === 'toggle-filters') {
          event.preventDefault();
          setFiltersOpen(rootElement.getAttribute('data-filters-open') !== 'true');
        } else if (action === 'syllables-increment') {
          event.preventDefault();
          adjustSyllables(1);
        } else if (action === 'syllables-decrement') {
          event.preventDefault();
          adjustSyllables(-1);
        } else if (action === 'expand-suggestions') {
          event.preventDefault();
          // Keep the dropdown open; do not re-focus the input here — focusout's
          // deferred hide treats focus leaving the panel as a close signal.
          renderSuggestions({ expand: true });
        } else if (action === 'generate') {
          event.preventDefault();
          startGeneration();
        } else if (action === 'search') {
          event.preventDefault();
          startSearch();
        }
      });

      if (generationForm) {
        generationForm.addEventListener('submit', function (event) {
          event.preventDefault();
          startGeneration();
        });
      }

      if (searchForm) {
        searchForm.addEventListener('submit', function (event) {
          event.preventDefault();
          startSearch();
        });
      }

      if (surnameInput) {
        var surnameField = surnameInput.closest('.yg-bn-generation__field--surname') || surnameInput.parentElement;

        // Prevent input blur when clicking expand / list chrome so the panel stays open.
        if (suggestionsPanel) {
          suggestionsPanel.addEventListener('mousedown', function (event) {
            if (event.target && event.target.closest('[data-baby-name-action="expand-suggestions"]')) {
              event.preventDefault();
            }
          });
        }

        surnameInput.addEventListener('input', renderSuggestions);
        surnameInput.addEventListener('focus', renderSuggestions);
        surnameInput.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') hideSuggestions();
        });
        surnameInput.addEventListener('focusout', function () {
          browserRoot.setTimeout(function () {
            var active = doc.activeElement;
            // Keep open while focus remains on the surname field or its dropdown.
            if (surnameField && active && surnameField.contains(active)) return;
            if (suggestionsPanel && active && suggestionsPanel.contains(active)) return;
            hideSuggestions();
          }, 0);
        });
      }

      if (searchInput) {
        searchInput.addEventListener('input', function () {
          if (normalizeText(searchInput.value)) setStatus(searchError, '');
          syncSearchButtonState();
        });
        searchInput.addEventListener('keypress', function (event) {
          if (event.key !== 'Enter') return;
          if (isSearching || !normalizeText(searchInput.value)) return;
          event.preventDefault();
          startSearch();
        });
      }

      syncSearchButtonState();
      setFiltersOpen(false);
    }

    function scan(doc, scope) {
      if (!doc) return;
      var target = scope && typeof scope.querySelectorAll === 'function' ? scope : doc;
      var roots = [];
      if (target.matches && target.matches('[data-baby-name-component="generation"]')) roots.push(target);
      target.querySelectorAll('[data-baby-name-component="generation"]').forEach(function (element) {
        roots.push(element);
      });
      roots.forEach(init);
    }

    function boot(doc) {
      if (!doc) return;
      var initialize = function () {
        scan(doc);
        if (initializedDocuments && initializedDocuments.has(doc)) return;
        if (initializedDocuments) initializedDocuments.add(doc);
        doc.addEventListener('shopify:section:load', function (event) {
          scan(doc, event.target);
        });
      };

      if (doc.readyState === 'loading') {
        doc.addEventListener('DOMContentLoaded', initialize, { once: true });
      } else {
        initialize();
      }
    }

    return {
      boot: boot,
      collectFormState: collectFormState,
      buildGeneratePayload: buildGeneratePayload,
      getSurnameSuggestions: getSurnameSuggestions,
      hasNameSearchResult: hasNameSearchResult,
      resolveSearchDetailName: resolveSearchDetailName,
      isSearchNameNotFoundError: isSearchNameNotFoundError,
      nameNotFoundMessage: nameNotFoundMessage,
    };
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-blog-article-banner"] && !Shopify.designMode) return;
  try {
    
  if (!window.YGBlogArticleBanner) {
    window.YGBlogArticleBanner = {
      init: function (root) {
        if (!window.ygProductActionButtons) return;

        var scope = root || document;
        var sections =
          scope.matches && scope.matches('[data-yg-blog-article-banner]')
            ? [scope]
            : scope.querySelectorAll('[data-yg-blog-article-banner]');

        sections.forEach(function (section) {
          window.ygProductActionButtons.bindSection(section, {
            addSelector: '[data-yg-blog-kv-add]',
            buySelector: '[data-yg-blog-kv-buy-disabled]',
            productFormSelector: '[data-yg-blog-kv-product-form]',
          });
        });
      },
    };

    document.addEventListener('shopify:section:load', function (event) {
      window.YGBlogArticleBanner.init(event.target);
    });
  }

  window.YGBlogArticleBanner.init(document);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-blog-article-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var isFirstLoad = !window.YGBlogArticleMain;
    window.YGBlogArticleMain = {
      getHeaderOffset: function () {
        if (window.YGBlogArticleNav && typeof window.YGBlogArticleNav.getHeaderOffset === 'function') {
          return window.YGBlogArticleNav.getHeaderOffset();
        }

        if (window.YGBlogArticleNav && typeof window.YGBlogArticleNav.getStickyStackOffset === 'function') {
          return window.YGBlogArticleNav.getStickyStackOffset();
        }

        var styles = getComputedStyle(document.documentElement);
        var header = parseFloat(styles.getPropertyValue('--header-height')) || 0;
        var announcement = parseFloat(styles.getPropertyValue('--announcement-bar-height')) || 0;
        var enableHeader = parseFloat(styles.getPropertyValue('--enable-sticky-header'));
        var enableAnnouncement = parseFloat(styles.getPropertyValue('--enable-sticky-announcement-bar'));

        if (isNaN(enableHeader)) enableHeader = 1;
        if (isNaN(enableAnnouncement)) enableAnnouncement = 0;

        return header * enableHeader + announcement * enableAnnouncement;
      },

      /*
        CSS already uses theme sticky-stack vars. Only override when measured
        header offset differs (vars lag or header taller than published height).
      */
      updateStickyTop: function (root) {
        if (!root) return;

        var stickyGap = 16;
        var offset = Math.max(0, Math.round(window.YGBlogArticleMain.getHeaderOffset()) + stickyGap);
        if (offset <= stickyGap) {
          root.style.removeProperty('--yg-blog-article-sidebar-sticky-top');
          return;
        }

        root.style.setProperty('--yg-blog-article-sidebar-sticky-top', offset + 'px');
      },

      bind: function (root) {
        if (!root) return;

        var api = window.YGBlogArticleMain;

        /* Always (re)bind subscribe — HTML/dialog may change across theme syncs. */
        api.bindKlaviyoFormVisibility(root);
        api.bindEmailSubscribe(root);

        if (root.dataset.ygBlogArticleMainInitialized === 'true') return;

        var frameId = null;

        function requestUpdate() {
          if (frameId !== null) return;
          frameId = window.requestAnimationFrame(function () {
            frameId = null;
            api.updateStickyTop(root);
          });
        }

        root.dataset.ygBlogArticleMainInitialized = 'true';
        api.enhanceTables(root);
        api.enhanceFaqs(root);
        api.updateStickyTop(root);
        /* Resize only — CSS vars cover sticky top during scroll. */
        window.addEventListener('resize', requestUpdate);
        root.ygBlogArticleMainCleanup = function () {
          if (typeof root.ygBlogEmailSubscribeClose === 'function') {
            root.ygBlogEmailSubscribeClose();
          }
          if (typeof root.ygBlogKlaviyoFormCleanup === 'function') {
            root.ygBlogKlaviyoFormCleanup();
          }
          window.removeEventListener('resize', requestUpdate);
          if (frameId !== null) window.cancelAnimationFrame(frameId);
          root.ygBlogArticleMainCleanup = null;
          root.ygBlogEmailSubscribeClose = null;
          root.ygBlogKlaviyoFormCleanup = null;
          delete root.dataset.ygBlogEmailSubscribeDelegated;
          delete root.dataset.ygBlogKlaviyoWatch;
        };
      },

      bindKlaviyoFormVisibility: function (root) {
        if (!root || root.dataset.ygBlogKlaviyoWatch === 'true') return;

        var slot = root.querySelector('[data-yg-blog-email-subscribe-slot]');
        var entry = root.querySelector('[data-yg-blog-email-subscribe-entry-slot]');
        if (!slot && !entry) return;

        if (window.Shopify && window.Shopify.designMode) return;

        root.dataset.ygBlogKlaviyoWatch = 'true';

        var formId = (slot && slot.getAttribute('data-klaviyo-form-id')) || (entry && entry.getAttribute('data-klaviyo-form-id')) || '';
        var selector = formId ? '.klaviyo-form-' + formId : '[class*="klaviyo-form-"]';
        var hideTimer = 0;
        var observer = null;

        function collectFormNodes() {
          var nodes = [];
          function addFrom(scope) {
            if (!scope || !scope.querySelectorAll) return;
            scope.querySelectorAll(selector).forEach(function (node) {
              if (nodes.indexOf(node) === -1) nodes.push(node);
            });
          }
          addFrom(root);
          addFrom(document);
          return nodes;
        }

        function formHasContent() {
          return collectFormNodes().some(function (node) {
            if (!node) return false;
            if (node.querySelector('iframe, form, input, button, textarea, select')) return true;
            return node.children.length > 0 || Boolean((node.textContent || '').trim());
          });
        }

        function setHidden(node, hide) {
          if (!node) return;
          node.hidden = hide;
          if (hide) node.setAttribute('hidden', '');
          else node.removeAttribute('hidden');
        }

        function syncVisibility() {
          var hide = !formHasContent();
          setHidden(slot, hide);
          setHidden(entry, hide);
        }

        function stopWatching() {
          if (hideTimer) {
            window.clearTimeout(hideTimer);
            hideTimer = 0;
          }
          if (observer) {
            observer.disconnect();
            observer = null;
          }
          document.removeEventListener('klaviyoForms', onKlaviyoForms);
        }

        function onKlaviyoForms() {
          syncVisibility();
          if (formHasContent()) stopWatching();
        }

        observer = new MutationObserver(function () {
          syncVisibility();
          if (formHasContent()) stopWatching();
        });

        [slot, entry, root].concat(collectFormNodes()).forEach(function (node) {
          if (!node) return;
          observer.observe(node, { childList: true, subtree: true });
        });

        document.addEventListener('klaviyoForms', onKlaviyoForms);
        syncVisibility();
        hideTimer = window.setTimeout(function () {
          hideTimer = 0;
          syncVisibility();
          if (formHasContent()) stopWatching();
        }, 8000);

        root.ygBlogKlaviyoFormCleanup = function () {
          stopWatching();
          delete root.dataset.ygBlogKlaviyoWatch;
          root.ygBlogKlaviyoFormCleanup = null;
        };
      },

      bindEmailSubscribe: function (root) {
        var dialog =
          root.querySelector('[data-yg-blog-email-subscribe-dialog]') ||
          document.querySelector(
            '.yg-blog-email-subscribe-dialog[data-section-id="' + (root.dataset.sectionId || '') + '"]'
          ) ||
          document.querySelector('[data-yg-blog-email-subscribe-dialog]');
        var triggers = root.querySelectorAll('[data-yg-blog-email-subscribe-trigger]');
        if (!dialog || !triggers.length) return;

        if (!dialog.getAttribute('data-section-id') && root.dataset.sectionId) {
          dialog.setAttribute('data-section-id', root.dataset.sectionId);
        }

        var previouslyFocused = null;
        var homeParent = dialog.parentNode === document.body ? root : dialog.parentNode;
        var homeNextSibling = dialog.parentNode === document.body ? null : dialog.nextSibling;

        function openDialog(trigger) {
          previouslyFocused = trigger || document.activeElement;

          if (dialog.parentNode !== document.body) {
            homeParent = dialog.parentNode;
            homeNextSibling = dialog.nextSibling;
            document.body.appendChild(dialog);
          }

          dialog.removeAttribute('hidden');
          dialog.hidden = false;
          document.body.classList.add('yg-blog-email-subscribe-dialog-open');

          var closeBtn = dialog.querySelector(
            '.yg-blog-email-subscribe-dialog__close[data-yg-blog-email-subscribe-dialog-close]'
          );
          if (closeBtn) closeBtn.focus();

          document.dispatchEvent(
            new CustomEvent('yg-blog:email-subscribe-open', {
              bubbles: true,
              detail: { trigger: previouslyFocused, dialog: dialog },
            })
          );
        }

        function closeDialog() {
          if (dialog.hasAttribute('hidden') && dialog.hidden) return;

          dialog.setAttribute('hidden', '');
          dialog.hidden = true;
          document.body.classList.remove('yg-blog-email-subscribe-dialog-open');

          if (homeParent && dialog.parentNode === document.body) {
            if (homeNextSibling && homeNextSibling.parentNode === homeParent) {
              homeParent.insertBefore(dialog, homeNextSibling);
            } else {
              homeParent.appendChild(dialog);
            }
          }

          document.dispatchEvent(
            new CustomEvent('yg-blog:email-subscribe-close', {
              bubbles: true,
              detail: { dialog: dialog },
            })
          );

          if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
            previouslyFocused.focus();
          }
          previouslyFocused = null;
        }

        root.ygBlogEmailSubscribeClose = closeDialog;
        root.ygBlogEmailSubscribeOpen = openDialog;

        triggers.forEach(function (trigger) {
          trigger.onclick = function (event) {
            event.preventDefault();
            event.stopPropagation();
            openDialog(trigger);
          };
        });

        dialog.querySelectorAll('[data-yg-blog-email-subscribe-dialog-close]').forEach(function (el) {
          el.onclick = function (event) {
            event.preventDefault();
            closeDialog();
          };
        });

        if (dialog.dataset.ygBlogEmailSubscribeEscBound !== 'true') {
          dialog.dataset.ygBlogEmailSubscribeEscBound = 'true';
          document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && !dialog.hidden) {
              event.preventDefault();
              closeDialog();
            }
          });
        }
      },

      enhanceTables: function (root) {
        root.querySelectorAll('[data-post-content] table').forEach(function (table) {
          if (table.parentElement && table.parentElement.classList.contains('yg-blog-article-table-scroll')) return;

          var scroller = document.createElement('div');
          scroller.className = 'yg-blog-article-table-scroll';
          scroller.setAttribute('role', 'region');
          scroller.setAttribute('aria-label', root.dataset.tableLabel);
          scroller.setAttribute('tabindex', '0');
          table.parentNode.insertBefore(scroller, table);
          scroller.appendChild(table);
        });
      },

      enhanceFaqs: function (root) {
        root.querySelectorAll('.blog-article-faq-container').forEach(function (container, faqIndex) {
          if (container.dataset.ygBlogArticleFaqInitialized === 'true') return;

          var headings = Array.prototype.filter.call(container.children, function (child) {
            return child.tagName === 'H3';
          });

          headings.forEach(function (heading, itemIndex) {
            var item = document.createElement('div');
            var panel = document.createElement('div');
            var panelInner = document.createElement('div');
            var button = document.createElement('button');
            var uid = root.dataset.sectionId + '-faq-' + faqIndex + '-' + itemIndex;
            var clipId = uid + '-chevron-clip';
            var iconTemplate = document.createElement('template');
            iconTemplate.innerHTML =
              '<svg class="yg-blog-article-faq__icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
              '<g clip-path="url(#' +
              clipId +
              ')">' +
              '<path d="M18.0352 15.2L12.9708 10.1356C12.385 9.54984 11.4353 9.54984 10.8495 10.1356L5.78516 15.2" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</g>' +
              '<defs><clipPath id="' +
              clipId +
              '"><rect width="14" height="7" fill="white" transform="translate(5.03516 8.94629)"/></clipPath></defs>' +
              '</svg>';
            var icon = iconTemplate.content.firstElementChild;

            item.className = 'yg-blog-article-faq__item is-expanded';
            heading.classList.add('yg-blog-article-faq__heading');
            heading.parentNode.insertBefore(item, heading);
            item.appendChild(heading);

            button.className = 'yg-blog-article-faq__button';
            button.type = 'button';
            button.id = uid + '-button';
            button.setAttribute('aria-expanded', 'true');
            button.setAttribute('aria-controls', uid + '-panel');
            while (heading.firstChild) button.appendChild(heading.firstChild);

            button.appendChild(icon);
            heading.appendChild(button);

            panel.className = 'yg-blog-article-faq__panel';
            panel.id = uid + '-panel';
            panel.setAttribute('role', 'region');
            panel.setAttribute('aria-labelledby', button.id);
            panel.setAttribute('aria-hidden', 'false');
            panelInner.className = 'yg-blog-article-faq__panel-inner';
            panel.appendChild(panelInner);

            while (item.nextSibling && !(item.nextSibling.nodeType === 1 && item.nextSibling.tagName === 'H3')) {
              panelInner.appendChild(item.nextSibling);
            }
            item.appendChild(panel);

            button.addEventListener('click', function () {
              var expanded = button.getAttribute('aria-expanded') === 'true';
              var nextExpanded = !expanded;
              button.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
              panel.setAttribute('aria-hidden', nextExpanded ? 'false' : 'true');
              item.classList.toggle('is-expanded', nextExpanded);

              if (nextExpanded) {
                panel.removeAttribute('inert');
              } else {
                panel.setAttribute('inert', '');
              }
            });
          });

          container.dataset.ygBlogArticleFaqInitialized = 'true';
        });
      },

      initProductSwipers: function (root) {
        if (!window.Swiper) return;

        root.querySelectorAll('[data-yg-blog-article-product-swiper]').forEach(function (swiperElement) {
          if (swiperElement.dataset.ygBlogArticleSwiperInitialized === 'true') return;

          swiperElement.ygBlogArticleSwiper = new window.Swiper(swiperElement, {
            slidesPerView: 1.5,
            spaceBetween: 8,
            watchOverflow: true,
            /* PC: center the row when only 2–3 cards (fewer than slidesPerView). */
            centerInsufficientSlides: true,
            breakpoints: {
              768: {
                slidesPerView: 3.1,
                spaceBetween: 8,
                centerInsufficientSlides: true,
              },
              1024: {
                slidesPerView: 3.5,
                spaceBetween: 8,
                centerInsufficientSlides: true,
              },
              1441: {
                slidesPerView: 4,
                spaceBetween: 8,
                centerInsufficientSlides: true,
              },
            },
          });
          swiperElement.dataset.ygBlogArticleSwiperInitialized = 'true';
        });
      },

      destroy: function (scope) {
        var context = scope || document;
        var roots =
          context.matches && context.matches('[data-yg-blog-article-main]')
            ? [context]
            : context.querySelectorAll('[data-yg-blog-article-main]');

        roots.forEach(function (root) {
          if (typeof root.ygBlogArticleMainCleanup === 'function') {
            root.ygBlogArticleMainCleanup();
          }

          root.querySelectorAll('[data-yg-blog-article-product-swiper]').forEach(function (swiperElement) {
            if (swiperElement.ygBlogArticleSwiper) {
              swiperElement.ygBlogArticleSwiper.destroy(true, true);
              swiperElement.ygBlogArticleSwiper = null;
            }
            delete swiperElement.dataset.ygBlogArticleSwiperInitialized;
          });

          delete root.dataset.ygBlogArticleMainInitialized;
        });
      },

      init: function (scope) {
        var context = scope || document;
        var roots =
          context.matches && context.matches('[data-yg-blog-article-main]')
            ? [context]
            : context.querySelectorAll('[data-yg-blog-article-main]');

        roots.forEach(function (root) {
          window.YGBlogArticleMain.bind(root);
          window.YGBlogArticleMain.initProductSwipers(root);
        });
      },
    };

    if (isFirstLoad) {
      document.addEventListener('shopify:section:load', function (event) {
        window.YGBlogArticleMain.init(event.target);
      });

      document.addEventListener('shopify:section:unload', function (event) {
        window.YGBlogArticleMain.destroy(event.target);
      });

      window.addEventListener(
        'load',
        function () {
          window.YGBlogArticleMain.init(document);
        },
        { once: true }
      );
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        window.YGBlogArticleMain.init(document);
      });
    } else {
      window.YGBlogArticleMain.init(document);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-gallery-item"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGGallerySlide extends HTMLElement {
      constructor() {
        super();
        this.handleResize = this.handleResize.bind(this);
        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
        this.initEntranceAnimation = this.initEntranceAnimation.bind(this);
        this.mobileSwiper = null;
        this.swiperCheckTimer = null;
        this.entranceTween = null;
      }

      get items() {
        return this.querySelectorAll('.yg-gallery-desktop .yg-gallery-item');
      }

      connectedCallback() {
        this.handleResize();
        this.initEntranceAnimation();
        window.addEventListener('resize', this.handleResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
        this.removeHoverListeners();
        this.clearSwiperCheckTimer();
        this.destroyMobileSwiper();

        if (this.entranceTween) {
          this.entranceTween.kill();
          this.entranceTween = null;
        }
      }

      handleResize() {
        if (window.innerWidth >= 750) {
          this.clearSwiperCheckTimer();
          this.destroyMobileSwiper();
          this.clearActiveState();
          this.addHoverListeners();
        } else {
          this.removeHoverListeners();
          this.clearActiveState();
          this.ensureMobileSwiper();
        }
      }

      addHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleMouseEnter);
          item.removeEventListener('mouseleave', this.handleMouseLeave);
          item.addEventListener('mouseenter', this.handleMouseEnter);
          item.addEventListener('mouseleave', this.handleMouseLeave);
        });
      }

      removeHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleMouseEnter);
          item.removeEventListener('mouseleave', this.handleMouseLeave);
        });
      }

      handleMouseEnter(e) {
        this.clearActiveState();
        e.currentTarget.classList.add('active');
      }

      handleMouseLeave() {
        this.clearActiveState();
      }

      clearActiveState() {
        this.items.forEach((item) => item.classList.remove('active'));
      }

      initEntranceAnimation() {
        if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
          console.warn('[YGGallerySlide] gsap or ScrollTrigger not ready');
          return;
        }

        gsap.registerPlugin(ScrollTrigger);

        if (this.entranceTween) {
          this.entranceTween.kill();
          this.entranceTween = null;
        }

        ScrollTrigger.getAll().forEach((trigger) => {
          if (trigger.vars && trigger.vars.trigger === this) {
            trigger.kill();
          }
        });

        gsap.set(this, {
          y: 50,
          force3D: true,
        });

        this.entranceTween = gsap.to(this, {
          y: 0,
          duration: 0.9,
          ease: 'power2.out',
          overwrite: true,
          force3D: true,
          onStart: () => {
            console.log('[YGGallerySlide] animation started', {
              rect: this.getBoundingClientRect(),
              computedTransform: window.getComputedStyle(this).transform,
            });
          },
          onComplete: () => {
            console.log('[YGGallerySlide] animation completed', {
              rect: this.getBoundingClientRect(),
              transform: this.style.transform,
              computedTransform: window.getComputedStyle(this).transform,
            });
          },
          scrollTrigger: {
            trigger: this,
            start: 'top 85%',
            toggleActions: 'play none none none',
            once: true,
            onEnter: (self) => {
              console.log('[YGGallerySlide] ScrollTrigger onEnter', {
                progress: self.progress,
                start: self.start,
                end: self.end,
                rect: this.getBoundingClientRect(),
              });
            },
            onRefresh: (self) => {
              console.log('[YGGallerySlide] ScrollTrigger onRefresh', {
                start: self.start,
                end: self.end,
                rect: this.getBoundingClientRect(),
              });
            },
          },
        });

        ScrollTrigger.refresh();
      }

      ensureMobileSwiper() {
        if (this.mobileSwiper || window.innerWidth >= 750) {
          return;
        }

        if (typeof Swiper !== 'undefined') {
          this.initMobileSwiper();
          return;
        }

        if (this.swiperCheckTimer) {
          return;
        }

        this.swiperCheckTimer = setInterval(() => {
          if (typeof Swiper !== 'undefined' && window.innerWidth < 750) {
            this.clearSwiperCheckTimer();
            this.initMobileSwiper();
          }
        }, 100);
      }

      clearSwiperCheckTimer() {
        if (!this.swiperCheckTimer) {
          return;
        }

        clearInterval(this.swiperCheckTimer);
        this.swiperCheckTimer = null;
      }

      initMobileSwiper() {
        if (window.innerWidth >= 750 || this.mobileSwiper || typeof Swiper === 'undefined') {
          return;
        }

        const swiperEl = this.querySelector('.yg-gallery-mobile-swiper');
        const paginationEl = this.querySelector('.yg-gallery-mobile-pagination');
        const nextEl = this.querySelector('.yg-gallery-mobile-next');
        const prevEl = this.querySelector('.yg-gallery-mobile-prev');

        if (!swiperEl || !paginationEl || !nextEl || !prevEl) {
          return;
        }

        this.mobileSwiper = new Swiper(swiperEl, {
          slidesPerView: 1.1,
          spaceBetween: 12,
          navigation: {
            nextEl,
            prevEl,
          },
          pagination: {
            el: paginationEl,
            clickable: true,
          },
        });
      }

      destroyMobileSwiper() {
        if (!this.mobileSwiper) {
          return;
        }

        this.mobileSwiper.destroy(true, true);
        this.mobileSwiper = null;
      }
    }

    if (!window.customElements.get('yg-gallery-slide')) {
      window.customElements.define('yg-gallery-slide', YGGallerySlide);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-nasal-aspirators-experts"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    var elementName = 'yg-nasal-aspirators-experts-mobile'

    if (customElements.get(elementName)) return

    customElements.define(
      elementName,
      class extends HTMLElement {
        connectedCallback() {
          this.buttons = Array.prototype.slice.call(this.querySelectorAll('[data-expert-index]'))
          this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-expert-card]'))
          this.activeIndex = Number(this.dataset.initialIndex || 0)

          if (!this.buttons.length) return

          this.buttons.forEach(
            function (button) {
              button.addEventListener(
                'click',
                function () {
                  this.setActive(Number(button.dataset.expertIndex), true)
                }.bind(this)
              )
            }.bind(this)
          )

          this.setActive(this.activeIndex, false)
        }

        setActive(index, shouldFocus) {
          var count = this.buttons.length
          if (!count) return

          this.activeIndex = Math.max(0, Math.min(index, count - 1))
          var previousIndex = (this.activeIndex - 1 + count) % count
          var nextIndex = (this.activeIndex + 1) % count

          this.buttons.forEach(
            function (button, buttonIndex) {
              var isActive = buttonIndex === this.activeIndex
              var isVisible = count < 3 || buttonIndex === this.activeIndex || buttonIndex === previousIndex || buttonIndex === nextIndex
              button.hidden = !isVisible
              button.classList.toggle('is-active', isActive)
              button.classList.toggle('is-left', !isActive && buttonIndex === previousIndex)
              button.classList.toggle('is-right', !isActive && buttonIndex === nextIndex)
              button.setAttribute('aria-selected', isActive ? 'true' : 'false')
            }.bind(this)
          )

          this.cards.forEach(
            function (card, cardIndex) {
              card.hidden = cardIndex !== this.activeIndex
            }.bind(this)
          )

          if (shouldFocus) this.buttons[this.activeIndex].focus()
        }
      }
    )
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-nasal-care-articles"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    var elementName = 'yg-nasal-care-articles-overflow'

    if (customElements.get(elementName)) return

    customElements.define(
      elementName,
      class extends HTMLElement {
        connectedCallback() {
          this.section = this.closest('.yg-nasal-care-articles--has-desktop-overflow')
          if (!this.section || !window.ResizeObserver) return

          this.desktopMedia = window.matchMedia('(min-width: 769px)')
          this.items = Array.prototype.slice.call(this.querySelectorAll('.yg-nasal-care-articles__item')).slice(0, 3)
          this.handleDesktopChange = this.updateHeight.bind(this)
          this.resizeObserver = new ResizeObserver(this.updateHeight.bind(this))

          this.desktopMedia.addEventListener('change', this.handleDesktopChange)
          this.items.forEach(
            function (item) {
              this.resizeObserver.observe(item)
            }.bind(this)
          )
          this.updateHeight()
        }

        disconnectedCallback() {
          if (this.desktopMedia) this.desktopMedia.removeEventListener('change', this.handleDesktopChange)
          if (this.resizeObserver) this.resizeObserver.disconnect()
        }

        updateHeight() {
          if (!this.section || !this.desktopMedia) return
          if (!this.desktopMedia.matches) {
            this.section.style.removeProperty('--yg-na-articles-right-list-height')
            return
          }

          if (!this.items.length) return

          var gap = Number.parseFloat(window.getComputedStyle(this).rowGap) || 0
          var listHeight = this.items.reduce(function (total, item) {
            return total + item.getBoundingClientRect().height
          }, 0)
          listHeight += gap * (this.items.length - 1)
          listHeight = Math.ceil(listHeight)

          if (listHeight > 0) this.section.style.setProperty('--yg-na-articles-right-list-height', listHeight + 'px')
        }
      }
    )
  })()

  } catch(e) { console.error(e); }
})();
})();
